/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as JoinRouteImport } from './routes/join'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as TrustRouteImport } from './routes/trust'
import { Route as AppSplatRouteImport } from './routes/_app/$'
import { Route as AppAppsRouteImport } from './routes/_app/apps'
import { Route as AppAudiencesRouteImport } from './routes/_app/audiences'
import { Route as AppExpensesRouteImport } from './routes/_app/expenses'
import { Route as AppFeedbackRouteImport } from './routes/_app/feedback'
import { Route as AppFollowsRouteImport } from './routes/_app/follows'
import { Route as AppGoalsRouteImport } from './routes/_app/goals'
import { Route as AppHomeRouteImport } from './routes/_app/home'
import { Route as AppPortfolioRouteImport } from './routes/_app/portfolio'
import { Route as AppPurchasesRouteImport } from './routes/_app/purchases'
import { Route as AppSurveysRouteImport } from './routes/_app/surveys'
import { Route as AppWebsiteRouteImport } from './routes/_app/website'
import { Route as AppWorkspacesRouteImport } from './routes/_app/workspaces'
import { Route as ApplyJobRouteImport } from './routes/apply/$job'
import { Route as FreelancerIndexRouteImport } from './routes/freelancer/index'
import { Route as HelpSlugRouteImport } from './routes/help/$slug'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as NTokenRouteImport } from './routes/n/$token'
import { Route as PortalIndexRouteImport } from './routes/portal/index'
import { Route as PortalBriefsRouteImport } from './routes/portal/briefs'
import { Route as PortalCalendarRouteImport } from './routes/portal/calendar'
import { Route as PortalChangesRouteImport } from './routes/portal/changes'
import { Route as PortalFilesRouteImport } from './routes/portal/files'
import { Route as PortalFormsRouteImport } from './routes/portal/forms'
import { Route as PortalHelpRouteImport } from './routes/portal/help'
import { Route as PortalMessagesRouteImport } from './routes/portal/messages'
import { Route as PortalMoneyRouteImport } from './routes/portal/money'
import { Route as PortalPlansRouteImport } from './routes/portal/plans'
import { Route as PortalReportsRouteImport } from './routes/portal/reports'
import { Route as PortalRequestsRouteImport } from './routes/portal/requests'
import { Route as PortalSettingsRouteImport } from './routes/portal/settings'
import { Route as PortalSignInRouteImport } from './routes/portal/sign-in'
import { Route as PortalSocialRouteImport } from './routes/portal/social'
import { Route as PortalStoreRouteImport } from './routes/portal/store'
import { Route as PortalTicketsRouteImport } from './routes/portal/tickets'
import { Route as PortalWelcomeRouteImport } from './routes/portal/welcome'
import { Route as RTokenRouteImport } from './routes/r/$token'
import { Route as SetupStepRouteImport } from './routes/setup/$step'
import { Route as AppAgreementsIndexRouteImport } from './routes/_app/agreements/index'
import { Route as AppAgreementsAgreementRouteImport } from './routes/_app/agreements/$agreement'
import { Route as AppAgreementsIdReviewsRouteImport } from './routes/_app/agreements/id-reviews'
import { Route as AppApprovalsIndexRouteImport } from './routes/_app/approvals/index'
import { Route as AppAssetsIndexRouteImport } from './routes/_app/assets/index'
import { Route as AppAutomationsIndexRouteImport } from './routes/_app/automations/index'
import { Route as AppAutomationsMapRouteImport } from './routes/_app/automations/map'
import { Route as AppAutomationsN8nRouteImport } from './routes/_app/automations/n8n'
import { Route as AppAutomationsRunsRouteImport } from './routes/_app/automations/runs'
import { Route as AppAutomationsTemplatesRouteImport } from './routes/_app/automations/templates'
import { Route as AppBookingsIndexRouteImport } from './routes/_app/bookings/index'
import { Route as AppBudgetsIndexRouteImport } from './routes/_app/budgets/index'
import { Route as AppBudgetsTabRouteImport } from './routes/_app/budgets/$tab'
import { Route as AppCalendarIndexRouteImport } from './routes/_app/calendar/index'
import { Route as AppCalendarOverlapRouteImport } from './routes/_app/calendar/overlap'
import { Route as AppCallsIndexRouteImport } from './routes/_app/calls/index'
import { Route as AppCallsPlaylistsRouteImport } from './routes/_app/calls/playlists'
import { Route as AppCampaignsIndexRouteImport } from './routes/_app/campaigns/index'
import { Route as AppCampaignsCampaignRouteImport } from './routes/_app/campaigns/$campaign'
import { Route as AppCatalogueTabRouteImport } from './routes/_app/catalogue/$tab'
import { Route as AppCatalogueStoreRouteImport } from './routes/_app/catalogue/store'
import { Route as AppChatIndexRouteImport } from './routes/_app/chat/index'
import { Route as AppChatChannelRouteImport } from './routes/_app/chat/$channel'
import { Route as AppClientsIndexRouteImport } from './routes/_app/clients/index'
import { Route as AppClientsDuplicatesRouteImport } from './routes/_app/clients/duplicates'
import { Route as AppContactsIndexRouteImport } from './routes/_app/contacts/index'
import { Route as AppContactsContactRouteImport } from './routes/_app/contacts/$contact'
import { Route as AppCyclesIndexRouteImport } from './routes/_app/cycles/index'
import { Route as AppCyclesCycleRouteImport } from './routes/_app/cycles/$cycle'
import { Route as AppDashboardsIndexRouteImport } from './routes/_app/dashboards/index'
import { Route as AppDashboardsDashboardRouteImport } from './routes/_app/dashboards/$dashboard'
import { Route as AppDealsIndexRouteImport } from './routes/_app/deals/index'
import { Route as AppDealsDealRouteImport } from './routes/_app/deals/$deal'
import { Route as AppDealsFollowUpsRouteImport } from './routes/_app/deals/follow-ups'
import { Route as AppDocsIndexRouteImport } from './routes/_app/docs/index'
import { Route as AppDocsDocRouteImport } from './routes/_app/docs/$doc'
import { Route as AppFilesIndexRouteImport } from './routes/_app/files/index'
import { Route as AppFilesFolderRouteImport } from './routes/_app/files/$folder'
import { Route as AppFilesStorageRouteImport } from './routes/_app/files/storage'
import { Route as AppFilesTrashRouteImport } from './routes/_app/files/trash'
import { Route as AppFinanceTabRouteImport } from './routes/_app/finance/$tab'
import { Route as AppFormsIndexRouteImport } from './routes/_app/forms/index'
import { Route as AppFreelancersIndexRouteImport } from './routes/_app/freelancers/index'
import { Route as AppFreelancersFreelancerRouteImport } from './routes/_app/freelancers/$freelancer'
import { Route as AppFreelancersPayoutsRouteImport } from './routes/_app/freelancers/payouts'
import { Route as AppFreelancersRequisitionsRouteImport } from './routes/_app/freelancers/requisitions'
import { Route as AppGettingStartedIndexRouteImport } from './routes/_app/getting-started/index'
import { Route as AppHelpCentreIndexRouteImport } from './routes/_app/help-centre/index'
import { Route as AppHiringIndexRouteImport } from './routes/_app/hiring/index'
import { Route as AppHiringJobRouteImport } from './routes/_app/hiring/$job'
import { Route as AppImportTypeRouteImport } from './routes/_app/import/$type'
import { Route as AppInboxIndexRouteImport } from './routes/_app/inbox/index'
import { Route as AppInboxThreadRouteImport } from './routes/_app/inbox/$thread'
import { Route as AppInboxWhatsappTemplatesRouteImport } from './routes/_app/inbox/whatsapp-templates'
import { Route as AppInitiativesIndexRouteImport } from './routes/_app/initiatives/index'
import { Route as AppInitiativesInitiativeRouteImport } from './routes/_app/initiatives/$initiative'
import { Route as AppInvoicesIndexRouteImport } from './routes/_app/invoices/index'
import { Route as AppInvoicesInvoiceRouteImport } from './routes/_app/invoices/$invoice'
import { Route as AppInvoicesAgingRouteImport } from './routes/_app/invoices/aging'
import { Route as AppLabFamilyRouteImport } from './routes/_app/lab/$family'
import { Route as AppLeaderboardIndexRouteImport } from './routes/_app/leaderboard/index'
import { Route as AppMeetingsIndexRouteImport } from './routes/_app/meetings/index'
import { Route as AppMeetingsMeetingRouteImport } from './routes/_app/meetings/$meeting'
import { Route as AppMyWorkIndexRouteImport } from './routes/_app/my-work/index'
import { Route as AppNotificationsIndexRouteImport } from './routes/_app/notifications/index'
import { Route as AppOIndexRouteImport } from './routes/_app/o/index'
import { Route as AppOnboardingIndexRouteImport } from './routes/_app/onboarding/index'
import { Route as AppOnboardingRunRouteImport } from './routes/_app/onboarding/$run'
import { Route as AppOneOnOnesPersonRouteImport } from './routes/_app/one-on-ones/$person'
import { Route as AppOutreachIndexRouteImport } from './routes/_app/outreach/index'
import { Route as AppOutreachSequenceRouteImport } from './routes/_app/outreach/$sequence'
import { Route as AppOutreachDeliverabilityRouteImport } from './routes/_app/outreach/deliverability'
import { Route as AppOutreachListsRouteImport } from './routes/_app/outreach/lists'
import { Route as AppOutreachMailboxesRouteImport } from './routes/_app/outreach/mailboxes'
import { Route as AppOutreachWarmupRouteImport } from './routes/_app/outreach/warmup'
import { Route as AppPaymentsIndexRouteImport } from './routes/_app/payments/index'
import { Route as AppPoliciesIndexRouteImport } from './routes/_app/policies/index'
import { Route as AppPortfoliosIndexRouteImport } from './routes/_app/portfolios/index'
import { Route as AppPortfoliosPortfolioRouteImport } from './routes/_app/portfolios/$portfolio'
import { Route as AppPresetsIndexRouteImport } from './routes/_app/presets/index'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppProofsIndexRouteImport } from './routes/_app/proofs/index'
import { Route as AppProofsProofRouteImport } from './routes/_app/proofs/$proof'
import { Route as AppProposalsIndexRouteImport } from './routes/_app/proposals/index'
import { Route as AppProposalsTemplatesRouteImport } from './routes/_app/proposals/templates'
import { Route as AppQueuesIndexRouteImport } from './routes/_app/queues/index'
import { Route as AppQueuesRoleRouteImport } from './routes/_app/queues/$role'
import { Route as AppReportsIndexRouteImport } from './routes/_app/reports/index'
import { Route as AppReportsReportRouteImport } from './routes/_app/reports/$report'
import { Route as AppReportsAttributionRouteImport } from './routes/_app/reports/attribution'
import { Route as AppReportsRevenueAnalyticsRouteImport } from './routes/_app/reports/revenue-analytics'
import { Route as AppReportsTargetsRouteImport } from './routes/_app/reports/targets'
import { Route as AppReviewsIndexRouteImport } from './routes/_app/reviews/index'
import { Route as AppSalesIndexRouteImport } from './routes/_app/sales/index'
import { Route as AppSalesRepRouteImport } from './routes/_app/sales/rep'
import { Route as AppSalesRulesRouteImport } from './routes/_app/sales/rules'
import { Route as AppScheduleIndexRouteImport } from './routes/_app/schedule/index'
import { Route as AppSearchIndexRouteImport } from './routes/_app/search/index'
import { Route as AppSocialIndexRouteImport } from './routes/_app/social/index'
import { Route as AppSpacesSpaceRouteImport } from './routes/_app/spaces/$space'
import { Route as AppSubscriptionsIndexRouteImport } from './routes/_app/subscriptions/index'
import { Route as AppSubscriptionsSubscriptionRouteImport } from './routes/_app/subscriptions/$subscription'
import { Route as AppSubscriptionsRecurringRouteImport } from './routes/_app/subscriptions/recurring'
import { Route as AppTasksKeyRouteImport } from './routes/_app/tasks/$key'
import { Route as AppTeamIndexRouteImport } from './routes/_app/team/index'
import { Route as AppTeamMemberRouteImport } from './routes/_app/team/$member'
import { Route as AppTicketsIndexRouteImport } from './routes/_app/tickets/index'
import { Route as AppTicketsTicketRouteImport } from './routes/_app/tickets/$ticket'
import { Route as AppTimeOffIndexRouteImport } from './routes/_app/time-off/index'
import { Route as AppTimeIndexRouteImport } from './routes/_app/time/index'
import { Route as AppTimeApprovalsRouteImport } from './routes/_app/time/approvals'
import { Route as AppTimeLedgerRouteImport } from './routes/_app/time/ledger'
import { Route as AppTimeTimerRouteImport } from './routes/_app/time/timer'
import { Route as AppToursIndexRouteImport } from './routes/_app/tours/index'
import { Route as AppToursStuckRouteImport } from './routes/_app/tours/stuck'
import { Route as AppTriageIndexRouteImport } from './routes/_app/triage/index'
import { Route as AppUpdatesIndexRouteImport } from './routes/_app/updates/index'
import { Route as AppVaultIndexRouteImport } from './routes/_app/vault/index'
import { Route as AppWebFeedbackIndexRouteImport } from './routes/_app/web-feedback/index'
import { Route as AppWhiteboardsIdRouteImport } from './routes/_app/whiteboards/$id'
import { Route as PActionTokenRouteImport } from './routes/p/action/$token'
import { Route as PBookSlugRouteImport } from './routes/p/book/$slug'
import { Route as PFormSlugRouteImport } from './routes/p/form/$slug'
import { Route as PFreelancerTokenRouteImport } from './routes/p/freelancer/$token'
import { Route as PHelpSlugRouteImport } from './routes/p/help/$slug'
import { Route as PPayTokenRouteImport } from './routes/p/pay/$token'
import { Route as PProposalTokenRouteImport } from './routes/p/proposal/$token'
import { Route as PShareTokenRouteImport } from './routes/p/share/$token'
import { Route as PSignTokenRouteImport } from './routes/p/sign/$token'
import { Route as PSurveyTokenRouteImport } from './routes/p/survey/$token'
import { Route as PTestimonialTokenRouteImport } from './routes/p/testimonial/$token'
import { Route as PUnsubscribeTokenRouteImport } from './routes/p/unsubscribe/$token'
import { Route as PUploadTokenRouteImport } from './routes/p/upload/$token'
import { Route as PortalApprovalsIndexRouteImport } from './routes/portal/approvals/index'
import { Route as PortalApprovalsApprovalRouteImport } from './routes/portal/approvals/$approval'
import { Route as PortalAppsTabRouteImport } from './routes/portal/apps/$tab'
import { Route as PortalProjectsIndexRouteImport } from './routes/portal/projects/index'
import { Route as PortalProjectsProjectRouteImport } from './routes/portal/projects/$project'
import { Route as AppAutomationsWorkflowIndexRouteImport } from './routes/_app/automations/$workflow/index'
import { Route as AppAutomationsMessagesIndexRouteImport } from './routes/_app/automations/messages/index'
import { Route as AppAutomationsMessagesTemplateRouteImport } from './routes/_app/automations/messages/$template'
import { Route as AppBookingsPagesPageRouteImport } from './routes/_app/bookings/pages/$page'
import { Route as AppClientsClientTabRouteImport } from './routes/_app/clients/$client/$tab'
import { Route as AppClientsClientLifecycleRouteImport } from './routes/_app/clients/$client/lifecycle'
import { Route as AppDashboardsTemplateTemplateRouteImport } from './routes/_app/dashboards/template.$template'
import { Route as AppFilesFileOfficeRouteImport } from './routes/_app/files/$file.office'
import { Route as AppFormsFormAnalyticsRouteImport } from './routes/_app/forms/$form/analytics'
import { Route as AppFormsFormEditRouteImport } from './routes/_app/forms/$form/edit'
import { Route as AppFormsFormResponsesRouteImport } from './routes/_app/forms/$form/responses'
import { Route as AppMyWorkListsListRouteImport } from './routes/_app/my-work/lists/$list'
import { Route as AppOObjectIndexRouteImport } from './routes/_app/o/$object/index'
import { Route as AppOObjectIdRouteImport } from './routes/_app/o/$object/$id'
import { Route as AppOnboardingTemplatesTemplateRouteImport } from './routes/_app/onboarding/templates/$template'
import { Route as AppProjectsProjectTabRouteImport } from './routes/_app/projects/$project/$tab'
import { Route as AppProjectsProjectScopeRouteImport } from './routes/_app/projects/$project/scope'
import { Route as AppProposalsProposalAnalyticsRouteImport } from './routes/_app/proposals/$proposal/analytics'
import { Route as AppProposalsProposalEditRouteImport } from './routes/_app/proposals/$proposal/edit'
import { Route as AppReportsClientsIndexRouteImport } from './routes/_app/reports/clients/index'
import { Route as AppReportsClientsClientRouteImport } from './routes/_app/reports/clients/$client'
import { Route as AppReportsPresentReportRouteImport } from './routes/_app/reports/present.$report'
import { Route as AppReviewsClientQuarterRouteImport } from './routes/_app/reviews/$client/$quarter'
import { Route as AppSettingsGroupPageRouteImport } from './routes/_app/settings/$group/$page'
import { Route as AppTemplatesKindTemplateRouteImport } from './routes/_app/templates/$kind/$template'
import { Route as AppWorkTemplatesIndexRouteImport } from './routes/_app/work/templates/index'
import { Route as AppWorkTemplatesTemplateRouteImport } from './routes/_app/work/templates/$template'
import { Route as PBookManageTokenRouteImport } from './routes/p/book/manage/$token'
import { Route as PReferralWsCodeRouteImport } from './routes/p/referral/$ws/$code'
import { Route as AppAutomationsWorkflowRunsRunRouteImport } from './routes/_app/automations/$workflow/runs/$run'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const TrustRoute = TrustRouteImport.update({
  id: '/trust',
  path: '/trust',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSplatRoute = AppSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AppRoute,
} as any)
const AppAppsRoute = AppAppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => AppRoute,
} as any)
const AppAudiencesRoute = AppAudiencesRouteImport.update({
  id: '/audiences',
  path: '/audiences',
  getParentRoute: () => AppRoute,
} as any)
const AppExpensesRoute = AppExpensesRouteImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => AppRoute,
} as any)
const AppFeedbackRoute = AppFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AppRoute,
} as any)
const AppFollowsRoute = AppFollowsRouteImport.update({
  id: '/follows',
  path: '/follows',
  getParentRoute: () => AppRoute,
} as any)
const AppGoalsRoute = AppGoalsRouteImport.update({
  id: '/goals',
  path: '/goals',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)
const AppPortfolioRoute = AppPortfolioRouteImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasesRoute = AppPurchasesRouteImport.update({
  id: '/purchases',
  path: '/purchases',
  getParentRoute: () => AppRoute,
} as any)
const AppSurveysRoute = AppSurveysRouteImport.update({
  id: '/surveys',
  path: '/surveys',
  getParentRoute: () => AppRoute,
} as any)
const AppWebsiteRoute = AppWebsiteRouteImport.update({
  id: '/website',
  path: '/website',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkspacesRoute = AppWorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => AppRoute,
} as any)
const ApplyJobRoute = ApplyJobRouteImport.update({
  id: '/apply/$job',
  path: '/apply/$job',
  getParentRoute: () => rootRouteImport,
} as any)
const FreelancerIndexRoute = FreelancerIndexRouteImport.update({
  id: '/freelancer/',
  path: '/freelancer/',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpSlugRoute = HelpSlugRouteImport.update({
  id: '/help/$slug',
  path: '/help/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const NTokenRoute = NTokenRouteImport.update({
  id: '/n/$token',
  path: '/n/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/portal/',
  path: '/portal/',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalBriefsRoute = PortalBriefsRouteImport.update({
  id: '/portal/briefs',
  path: '/portal/briefs',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalCalendarRoute = PortalCalendarRouteImport.update({
  id: '/portal/calendar',
  path: '/portal/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalChangesRoute = PortalChangesRouteImport.update({
  id: '/portal/changes',
  path: '/portal/changes',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalFilesRoute = PortalFilesRouteImport.update({
  id: '/portal/files',
  path: '/portal/files',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalFormsRoute = PortalFormsRouteImport.update({
  id: '/portal/forms',
  path: '/portal/forms',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalHelpRoute = PortalHelpRouteImport.update({
  id: '/portal/help',
  path: '/portal/help',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalMessagesRoute = PortalMessagesRouteImport.update({
  id: '/portal/messages',
  path: '/portal/messages',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalMoneyRoute = PortalMoneyRouteImport.update({
  id: '/portal/money',
  path: '/portal/money',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalPlansRoute = PortalPlansRouteImport.update({
  id: '/portal/plans',
  path: '/portal/plans',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalReportsRoute = PortalReportsRouteImport.update({
  id: '/portal/reports',
  path: '/portal/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRequestsRoute = PortalRequestsRouteImport.update({
  id: '/portal/requests',
  path: '/portal/requests',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalSettingsRoute = PortalSettingsRouteImport.update({
  id: '/portal/settings',
  path: '/portal/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalSignInRoute = PortalSignInRouteImport.update({
  id: '/portal/sign-in',
  path: '/portal/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalSocialRoute = PortalSocialRouteImport.update({
  id: '/portal/social',
  path: '/portal/social',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalStoreRoute = PortalStoreRouteImport.update({
  id: '/portal/store',
  path: '/portal/store',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalTicketsRoute = PortalTicketsRouteImport.update({
  id: '/portal/tickets',
  path: '/portal/tickets',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalWelcomeRoute = PortalWelcomeRouteImport.update({
  id: '/portal/welcome',
  path: '/portal/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const RTokenRoute = RTokenRouteImport.update({
  id: '/r/$token',
  path: '/r/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupStepRoute = SetupStepRouteImport.update({
  id: '/setup/$step',
  path: '/setup/$step',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAgreementsIndexRoute = AppAgreementsIndexRouteImport.update({
  id: '/agreements/',
  path: '/agreements/',
  getParentRoute: () => AppRoute,
} as any)
const AppAgreementsAgreementRoute = AppAgreementsAgreementRouteImport.update({
  id: '/agreements/$agreement',
  path: '/agreements/$agreement',
  getParentRoute: () => AppRoute,
} as any)
const AppAgreementsIdReviewsRoute = AppAgreementsIdReviewsRouteImport.update({
  id: '/agreements/id-reviews',
  path: '/agreements/id-reviews',
  getParentRoute: () => AppRoute,
} as any)
const AppApprovalsIndexRoute = AppApprovalsIndexRouteImport.update({
  id: '/approvals/',
  path: '/approvals/',
  getParentRoute: () => AppRoute,
} as any)
const AppAssetsIndexRoute = AppAssetsIndexRouteImport.update({
  id: '/assets/',
  path: '/assets/',
  getParentRoute: () => AppRoute,
} as any)
const AppAutomationsIndexRoute = AppAutomationsIndexRouteImport.update({
  id: '/automations/',
  path: '/automations/',
  getParentRoute: () => AppRoute,
} as any)
const AppAutomationsMapRoute = AppAutomationsMapRouteImport.update({
  id: '/automations/map',
  path: '/automations/map',
  getParentRoute: () => AppRoute,
} as any)
const AppAutomationsN8nRoute = AppAutomationsN8nRouteImport.update({
  id: '/automations/n8n',
  path: '/automations/n8n',
  getParentRoute: () => AppRoute,
} as any)
const AppAutomationsRunsRoute = AppAutomationsRunsRouteImport.update({
  id: '/automations/runs',
  path: '/automations/runs',
  getParentRoute: () => AppRoute,
} as any)
const AppAutomationsTemplatesRoute = AppAutomationsTemplatesRouteImport.update({
  id: '/automations/templates',
  path: '/automations/templates',
  getParentRoute: () => AppRoute,
} as any)
const AppBookingsIndexRoute = AppBookingsIndexRouteImport.update({
  id: '/bookings/',
  path: '/bookings/',
  getParentRoute: () => AppRoute,
} as any)
const AppBudgetsIndexRoute = AppBudgetsIndexRouteImport.update({
  id: '/budgets/',
  path: '/budgets/',
  getParentRoute: () => AppRoute,
} as any)
const AppBudgetsTabRoute = AppBudgetsTabRouteImport.update({
  id: '/budgets/$tab',
  path: '/budgets/$tab',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarIndexRoute = AppCalendarIndexRouteImport.update({
  id: '/calendar/',
  path: '/calendar/',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarOverlapRoute = AppCalendarOverlapRouteImport.update({
  id: '/calendar/overlap',
  path: '/calendar/overlap',
  getParentRoute: () => AppRoute,
} as any)
const AppCallsIndexRoute = AppCallsIndexRouteImport.update({
  id: '/calls/',
  path: '/calls/',
  getParentRoute: () => AppRoute,
} as any)
const AppCallsPlaylistsRoute = AppCallsPlaylistsRouteImport.update({
  id: '/calls/playlists',
  path: '/calls/playlists',
  getParentRoute: () => AppRoute,
} as any)
const AppCampaignsIndexRoute = AppCampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => AppRoute,
} as any)
const AppCampaignsCampaignRoute = AppCampaignsCampaignRouteImport.update({
  id: '/campaigns/$campaign',
  path: '/campaigns/$campaign',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogueTabRoute = AppCatalogueTabRouteImport.update({
  id: '/catalogue/$tab',
  path: '/catalogue/$tab',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogueStoreRoute = AppCatalogueStoreRouteImport.update({
  id: '/catalogue/store',
  path: '/catalogue/store',
  getParentRoute: () => AppRoute,
} as any)
const AppChatIndexRoute = AppChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => AppRoute,
} as any)
const AppChatChannelRoute = AppChatChannelRouteImport.update({
  id: '/chat/$channel',
  path: '/chat/$channel',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsDuplicatesRoute = AppClientsDuplicatesRouteImport.update({
  id: '/clients/duplicates',
  path: '/clients/duplicates',
  getParentRoute: () => AppRoute,
} as any)
const AppContactsIndexRoute = AppContactsIndexRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => AppRoute,
} as any)
const AppContactsContactRoute = AppContactsContactRouteImport.update({
  id: '/contacts/$contact',
  path: '/contacts/$contact',
  getParentRoute: () => AppRoute,
} as any)
const AppCyclesIndexRoute = AppCyclesIndexRouteImport.update({
  id: '/cycles/',
  path: '/cycles/',
  getParentRoute: () => AppRoute,
} as any)
const AppCyclesCycleRoute = AppCyclesCycleRouteImport.update({
  id: '/cycles/$cycle',
  path: '/cycles/$cycle',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardsIndexRoute = AppDashboardsIndexRouteImport.update({
  id: '/dashboards/',
  path: '/dashboards/',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardsDashboardRoute = AppDashboardsDashboardRouteImport.update({
  id: '/dashboards/$dashboard',
  path: '/dashboards/$dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppDealsIndexRoute = AppDealsIndexRouteImport.update({
  id: '/deals/',
  path: '/deals/',
  getParentRoute: () => AppRoute,
} as any)
const AppDealsDealRoute = AppDealsDealRouteImport.update({
  id: '/deals/$deal',
  path: '/deals/$deal',
  getParentRoute: () => AppRoute,
} as any)
const AppDealsFollowUpsRoute = AppDealsFollowUpsRouteImport.update({
  id: '/deals/follow-ups',
  path: '/deals/follow-ups',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsIndexRoute = AppDocsIndexRouteImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsDocRoute = AppDocsDocRouteImport.update({
  id: '/docs/$doc',
  path: '/docs/$doc',
  getParentRoute: () => AppRoute,
} as any)
const AppFilesIndexRoute = AppFilesIndexRouteImport.update({
  id: '/files/',
  path: '/files/',
  getParentRoute: () => AppRoute,
} as any)
const AppFilesFolderRoute = AppFilesFolderRouteImport.update({
  id: '/files/$folder',
  path: '/files/$folder',
  getParentRoute: () => AppRoute,
} as any)
const AppFilesStorageRoute = AppFilesStorageRouteImport.update({
  id: '/files/storage',
  path: '/files/storage',
  getParentRoute: () => AppRoute,
} as any)
const AppFilesTrashRoute = AppFilesTrashRouteImport.update({
  id: '/files/trash',
  path: '/files/trash',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceTabRoute = AppFinanceTabRouteImport.update({
  id: '/finance/$tab',
  path: '/finance/$tab',
  getParentRoute: () => AppRoute,
} as any)
const AppFormsIndexRoute = AppFormsIndexRouteImport.update({
  id: '/forms/',
  path: '/forms/',
  getParentRoute: () => AppRoute,
} as any)
const AppFreelancersIndexRoute = AppFreelancersIndexRouteImport.update({
  id: '/freelancers/',
  path: '/freelancers/',
  getParentRoute: () => AppRoute,
} as any)
const AppFreelancersFreelancerRoute =
  AppFreelancersFreelancerRouteImport.update({
    id: '/freelancers/$freelancer',
    path: '/freelancers/$freelancer',
    getParentRoute: () => AppRoute,
  } as any)
const AppFreelancersPayoutsRoute = AppFreelancersPayoutsRouteImport.update({
  id: '/freelancers/payouts',
  path: '/freelancers/payouts',
  getParentRoute: () => AppRoute,
} as any)
const AppFreelancersRequisitionsRoute =
  AppFreelancersRequisitionsRouteImport.update({
    id: '/freelancers/requisitions',
    path: '/freelancers/requisitions',
    getParentRoute: () => AppRoute,
  } as any)
const AppGettingStartedIndexRoute = AppGettingStartedIndexRouteImport.update({
  id: '/getting-started/',
  path: '/getting-started/',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpCentreIndexRoute = AppHelpCentreIndexRouteImport.update({
  id: '/help-centre/',
  path: '/help-centre/',
  getParentRoute: () => AppRoute,
} as any)
const AppHiringIndexRoute = AppHiringIndexRouteImport.update({
  id: '/hiring/',
  path: '/hiring/',
  getParentRoute: () => AppRoute,
} as any)
const AppHiringJobRoute = AppHiringJobRouteImport.update({
  id: '/hiring/$job',
  path: '/hiring/$job',
  getParentRoute: () => AppRoute,
} as any)
const AppImportTypeRoute = AppImportTypeRouteImport.update({
  id: '/import/$type',
  path: '/import/$type',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxIndexRoute = AppInboxIndexRouteImport.update({
  id: '/inbox/',
  path: '/inbox/',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxThreadRoute = AppInboxThreadRouteImport.update({
  id: '/inbox/$thread',
  path: '/inbox/$thread',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxWhatsappTemplatesRoute =
  AppInboxWhatsappTemplatesRouteImport.update({
    id: '/inbox/whatsapp-templates',
    path: '/inbox/whatsapp-templates',
    getParentRoute: () => AppRoute,
  } as any)
const AppInitiativesIndexRoute = AppInitiativesIndexRouteImport.update({
  id: '/initiatives/',
  path: '/initiatives/',
  getParentRoute: () => AppRoute,
} as any)
const AppInitiativesInitiativeRoute =
  AppInitiativesInitiativeRouteImport.update({
    id: '/initiatives/$initiative',
    path: '/initiatives/$initiative',
    getParentRoute: () => AppRoute,
  } as any)
const AppInvoicesIndexRoute = AppInvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesInvoiceRoute = AppInvoicesInvoiceRouteImport.update({
  id: '/invoices/$invoice',
  path: '/invoices/$invoice',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesAgingRoute = AppInvoicesAgingRouteImport.update({
  id: '/invoices/aging',
  path: '/invoices/aging',
  getParentRoute: () => AppRoute,
} as any)
const AppLabFamilyRoute = AppLabFamilyRouteImport.update({
  id: '/lab/$family',
  path: '/lab/$family',
  getParentRoute: () => AppRoute,
} as any)
const AppLeaderboardIndexRoute = AppLeaderboardIndexRouteImport.update({
  id: '/leaderboard/',
  path: '/leaderboard/',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsIndexRoute = AppMeetingsIndexRouteImport.update({
  id: '/meetings/',
  path: '/meetings/',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsMeetingRoute = AppMeetingsMeetingRouteImport.update({
  id: '/meetings/$meeting',
  path: '/meetings/$meeting',
  getParentRoute: () => AppRoute,
} as any)
const AppMyWorkIndexRoute = AppMyWorkIndexRouteImport.update({
  id: '/my-work/',
  path: '/my-work/',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsIndexRoute = AppNotificationsIndexRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => AppRoute,
} as any)
const AppOIndexRoute = AppOIndexRouteImport.update({
  id: '/o/',
  path: '/o/',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingIndexRoute = AppOnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingRunRoute = AppOnboardingRunRouteImport.update({
  id: '/onboarding/$run',
  path: '/onboarding/$run',
  getParentRoute: () => AppRoute,
} as any)
const AppOneOnOnesPersonRoute = AppOneOnOnesPersonRouteImport.update({
  id: '/one-on-ones/$person',
  path: '/one-on-ones/$person',
  getParentRoute: () => AppRoute,
} as any)
const AppOutreachIndexRoute = AppOutreachIndexRouteImport.update({
  id: '/outreach/',
  path: '/outreach/',
  getParentRoute: () => AppRoute,
} as any)
const AppOutreachSequenceRoute = AppOutreachSequenceRouteImport.update({
  id: '/outreach/$sequence',
  path: '/outreach/$sequence',
  getParentRoute: () => AppRoute,
} as any)
const AppOutreachDeliverabilityRoute =
  AppOutreachDeliverabilityRouteImport.update({
    id: '/outreach/deliverability',
    path: '/outreach/deliverability',
    getParentRoute: () => AppRoute,
  } as any)
const AppOutreachListsRoute = AppOutreachListsRouteImport.update({
  id: '/outreach/lists',
  path: '/outreach/lists',
  getParentRoute: () => AppRoute,
} as any)
const AppOutreachMailboxesRoute = AppOutreachMailboxesRouteImport.update({
  id: '/outreach/mailboxes',
  path: '/outreach/mailboxes',
  getParentRoute: () => AppRoute,
} as any)
const AppOutreachWarmupRoute = AppOutreachWarmupRouteImport.update({
  id: '/outreach/warmup',
  path: '/outreach/warmup',
  getParentRoute: () => AppRoute,
} as any)
const AppPaymentsIndexRoute = AppPaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => AppRoute,
} as any)
const AppPoliciesIndexRoute = AppPoliciesIndexRouteImport.update({
  id: '/policies/',
  path: '/policies/',
  getParentRoute: () => AppRoute,
} as any)
const AppPortfoliosIndexRoute = AppPortfoliosIndexRouteImport.update({
  id: '/portfolios/',
  path: '/portfolios/',
  getParentRoute: () => AppRoute,
} as any)
const AppPortfoliosPortfolioRoute = AppPortfoliosPortfolioRouteImport.update({
  id: '/portfolios/$portfolio',
  path: '/portfolios/$portfolio',
  getParentRoute: () => AppRoute,
} as any)
const AppPresetsIndexRoute = AppPresetsIndexRouteImport.update({
  id: '/presets/',
  path: '/presets/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProofsIndexRoute = AppProofsIndexRouteImport.update({
  id: '/proofs/',
  path: '/proofs/',
  getParentRoute: () => AppRoute,
} as any)
const AppProofsProofRoute = AppProofsProofRouteImport.update({
  id: '/proofs/$proof',
  path: '/proofs/$proof',
  getParentRoute: () => AppRoute,
} as any)
const AppProposalsIndexRoute = AppProposalsIndexRouteImport.update({
  id: '/proposals/',
  path: '/proposals/',
  getParentRoute: () => AppRoute,
} as any)
const AppProposalsTemplatesRoute = AppProposalsTemplatesRouteImport.update({
  id: '/proposals/templates',
  path: '/proposals/templates',
  getParentRoute: () => AppRoute,
} as any)
const AppQueuesIndexRoute = AppQueuesIndexRouteImport.update({
  id: '/queues/',
  path: '/queues/',
  getParentRoute: () => AppRoute,
} as any)
const AppQueuesRoleRoute = AppQueuesRoleRouteImport.update({
  id: '/queues/$role',
  path: '/queues/$role',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsReportRoute = AppReportsReportRouteImport.update({
  id: '/reports/$report',
  path: '/reports/$report',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsAttributionRoute = AppReportsAttributionRouteImport.update({
  id: '/reports/attribution',
  path: '/reports/attribution',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRevenueAnalyticsRoute =
  AppReportsRevenueAnalyticsRouteImport.update({
    id: '/reports/revenue-analytics',
    path: '/reports/revenue-analytics',
    getParentRoute: () => AppRoute,
  } as any)
const AppReportsTargetsRoute = AppReportsTargetsRouteImport.update({
  id: '/reports/targets',
  path: '/reports/targets',
  getParentRoute: () => AppRoute,
} as any)
const AppReviewsIndexRoute = AppReviewsIndexRouteImport.update({
  id: '/reviews/',
  path: '/reviews/',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesIndexRoute = AppSalesIndexRouteImport.update({
  id: '/sales/',
  path: '/sales/',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesRepRoute = AppSalesRepRouteImport.update({
  id: '/sales/rep',
  path: '/sales/rep',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesRulesRoute = AppSalesRulesRouteImport.update({
  id: '/sales/rules',
  path: '/sales/rules',
  getParentRoute: () => AppRoute,
} as any)
const AppScheduleIndexRoute = AppScheduleIndexRouteImport.update({
  id: '/schedule/',
  path: '/schedule/',
  getParentRoute: () => AppRoute,
} as any)
const AppSearchIndexRoute = AppSearchIndexRouteImport.update({
  id: '/search/',
  path: '/search/',
  getParentRoute: () => AppRoute,
} as any)
const AppSocialIndexRoute = AppSocialIndexRouteImport.update({
  id: '/social/',
  path: '/social/',
  getParentRoute: () => AppRoute,
} as any)
const AppSpacesSpaceRoute = AppSpacesSpaceRouteImport.update({
  id: '/spaces/$space',
  path: '/spaces/$space',
  getParentRoute: () => AppRoute,
} as any)
const AppSubscriptionsIndexRoute = AppSubscriptionsIndexRouteImport.update({
  id: '/subscriptions/',
  path: '/subscriptions/',
  getParentRoute: () => AppRoute,
} as any)
const AppSubscriptionsSubscriptionRoute =
  AppSubscriptionsSubscriptionRouteImport.update({
    id: '/subscriptions/$subscription',
    path: '/subscriptions/$subscription',
    getParentRoute: () => AppRoute,
  } as any)
const AppSubscriptionsRecurringRoute =
  AppSubscriptionsRecurringRouteImport.update({
    id: '/subscriptions/recurring',
    path: '/subscriptions/recurring',
    getParentRoute: () => AppRoute,
  } as any)
const AppTasksKeyRoute = AppTasksKeyRouteImport.update({
  id: '/tasks/$key',
  path: '/tasks/$key',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamIndexRoute = AppTeamIndexRouteImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamMemberRoute = AppTeamMemberRouteImport.update({
  id: '/team/$member',
  path: '/team/$member',
  getParentRoute: () => AppRoute,
} as any)
const AppTicketsIndexRoute = AppTicketsIndexRouteImport.update({
  id: '/tickets/',
  path: '/tickets/',
  getParentRoute: () => AppRoute,
} as any)
const AppTicketsTicketRoute = AppTicketsTicketRouteImport.update({
  id: '/tickets/$ticket',
  path: '/tickets/$ticket',
  getParentRoute: () => AppRoute,
} as any)
const AppTimeOffIndexRoute = AppTimeOffIndexRouteImport.update({
  id: '/time-off/',
  path: '/time-off/',
  getParentRoute: () => AppRoute,
} as any)
const AppTimeIndexRoute = AppTimeIndexRouteImport.update({
  id: '/time/',
  path: '/time/',
  getParentRoute: () => AppRoute,
} as any)
const AppTimeApprovalsRoute = AppTimeApprovalsRouteImport.update({
  id: '/time/approvals',
  path: '/time/approvals',
  getParentRoute: () => AppRoute,
} as any)
const AppTimeLedgerRoute = AppTimeLedgerRouteImport.update({
  id: '/time/ledger',
  path: '/time/ledger',
  getParentRoute: () => AppRoute,
} as any)
const AppTimeTimerRoute = AppTimeTimerRouteImport.update({
  id: '/time/timer',
  path: '/time/timer',
  getParentRoute: () => AppRoute,
} as any)
const AppToursIndexRoute = AppToursIndexRouteImport.update({
  id: '/tours/',
  path: '/tours/',
  getParentRoute: () => AppRoute,
} as any)
const AppToursStuckRoute = AppToursStuckRouteImport.update({
  id: '/tours/stuck',
  path: '/tours/stuck',
  getParentRoute: () => AppRoute,
} as any)
const AppTriageIndexRoute = AppTriageIndexRouteImport.update({
  id: '/triage/',
  path: '/triage/',
  getParentRoute: () => AppRoute,
} as any)
const AppUpdatesIndexRoute = AppUpdatesIndexRouteImport.update({
  id: '/updates/',
  path: '/updates/',
  getParentRoute: () => AppRoute,
} as any)
const AppVaultIndexRoute = AppVaultIndexRouteImport.update({
  id: '/vault/',
  path: '/vault/',
  getParentRoute: () => AppRoute,
} as any)
const AppWebFeedbackIndexRoute = AppWebFeedbackIndexRouteImport.update({
  id: '/web-feedback/',
  path: '/web-feedback/',
  getParentRoute: () => AppRoute,
} as any)
const AppWhiteboardsIdRoute = AppWhiteboardsIdRouteImport.update({
  id: '/whiteboards/$id',
  path: '/whiteboards/$id',
  getParentRoute: () => AppRoute,
} as any)
const PActionTokenRoute = PActionTokenRouteImport.update({
  id: '/p/action/$token',
  path: '/p/action/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PBookSlugRoute = PBookSlugRouteImport.update({
  id: '/p/book/$slug',
  path: '/p/book/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const PFormSlugRoute = PFormSlugRouteImport.update({
  id: '/p/form/$slug',
  path: '/p/form/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const PFreelancerTokenRoute = PFreelancerTokenRouteImport.update({
  id: '/p/freelancer/$token',
  path: '/p/freelancer/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PHelpSlugRoute = PHelpSlugRouteImport.update({
  id: '/p/help/$slug',
  path: '/p/help/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const PPayTokenRoute = PPayTokenRouteImport.update({
  id: '/p/pay/$token',
  path: '/p/pay/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PProposalTokenRoute = PProposalTokenRouteImport.update({
  id: '/p/proposal/$token',
  path: '/p/proposal/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PShareTokenRoute = PShareTokenRouteImport.update({
  id: '/p/share/$token',
  path: '/p/share/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PSignTokenRoute = PSignTokenRouteImport.update({
  id: '/p/sign/$token',
  path: '/p/sign/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PSurveyTokenRoute = PSurveyTokenRouteImport.update({
  id: '/p/survey/$token',
  path: '/p/survey/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PTestimonialTokenRoute = PTestimonialTokenRouteImport.update({
  id: '/p/testimonial/$token',
  path: '/p/testimonial/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PUnsubscribeTokenRoute = PUnsubscribeTokenRouteImport.update({
  id: '/p/unsubscribe/$token',
  path: '/p/unsubscribe/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PUploadTokenRoute = PUploadTokenRouteImport.update({
  id: '/p/upload/$token',
  path: '/p/upload/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalApprovalsIndexRoute = PortalApprovalsIndexRouteImport.update({
  id: '/portal/approvals/',
  path: '/portal/approvals/',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalApprovalsApprovalRoute = PortalApprovalsApprovalRouteImport.update({
  id: '/portal/approvals/$approval',
  path: '/portal/approvals/$approval',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalAppsTabRoute = PortalAppsTabRouteImport.update({
  id: '/portal/apps/$tab',
  path: '/portal/apps/$tab',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalProjectsIndexRoute = PortalProjectsIndexRouteImport.update({
  id: '/portal/projects/',
  path: '/portal/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalProjectsProjectRoute = PortalProjectsProjectRouteImport.update({
  id: '/portal/projects/$project',
  path: '/portal/projects/$project',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAutomationsWorkflowIndexRoute =
  AppAutomationsWorkflowIndexRouteImport.update({
    id: '/automations/$workflow/',
    path: '/automations/$workflow/',
    getParentRoute: () => AppRoute,
  } as any)
const AppAutomationsMessagesIndexRoute =
  AppAutomationsMessagesIndexRouteImport.update({
    id: '/automations/messages/',
    path: '/automations/messages/',
    getParentRoute: () => AppRoute,
  } as any)
const AppAutomationsMessagesTemplateRoute =
  AppAutomationsMessagesTemplateRouteImport.update({
    id: '/automations/messages/$template',
    path: '/automations/messages/$template',
    getParentRoute: () => AppRoute,
  } as any)
const AppBookingsPagesPageRoute = AppBookingsPagesPageRouteImport.update({
  id: '/bookings/pages/$page',
  path: '/bookings/pages/$page',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsClientTabRoute = AppClientsClientTabRouteImport.update({
  id: '/clients/$client/$tab',
  path: '/clients/$client/$tab',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsClientLifecycleRoute =
  AppClientsClientLifecycleRouteImport.update({
    id: '/clients/$client/lifecycle',
    path: '/clients/$client/lifecycle',
    getParentRoute: () => AppRoute,
  } as any)
const AppDashboardsTemplateTemplateRoute =
  AppDashboardsTemplateTemplateRouteImport.update({
    id: '/dashboards/template/$template',
    path: '/dashboards/template/$template',
    getParentRoute: () => AppRoute,
  } as any)
const AppFilesFileOfficeRoute = AppFilesFileOfficeRouteImport.update({
  id: '/files/$file/office',
  path: '/files/$file/office',
  getParentRoute: () => AppRoute,
} as any)
const AppFormsFormAnalyticsRoute = AppFormsFormAnalyticsRouteImport.update({
  id: '/forms/$form/analytics',
  path: '/forms/$form/analytics',
  getParentRoute: () => AppRoute,
} as any)
const AppFormsFormEditRoute = AppFormsFormEditRouteImport.update({
  id: '/forms/$form/edit',
  path: '/forms/$form/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppFormsFormResponsesRoute = AppFormsFormResponsesRouteImport.update({
  id: '/forms/$form/responses',
  path: '/forms/$form/responses',
  getParentRoute: () => AppRoute,
} as any)
const AppMyWorkListsListRoute = AppMyWorkListsListRouteImport.update({
  id: '/my-work/lists/$list',
  path: '/my-work/lists/$list',
  getParentRoute: () => AppRoute,
} as any)
const AppOObjectIndexRoute = AppOObjectIndexRouteImport.update({
  id: '/o/$object/',
  path: '/o/$object/',
  getParentRoute: () => AppRoute,
} as any)
const AppOObjectIdRoute = AppOObjectIdRouteImport.update({
  id: '/o/$object/$id',
  path: '/o/$object/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingTemplatesTemplateRoute =
  AppOnboardingTemplatesTemplateRouteImport.update({
    id: '/onboarding/templates/$template',
    path: '/onboarding/templates/$template',
    getParentRoute: () => AppRoute,
  } as any)
const AppProjectsProjectTabRoute = AppProjectsProjectTabRouteImport.update({
  id: '/projects/$project/$tab',
  path: '/projects/$project/$tab',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectScopeRoute = AppProjectsProjectScopeRouteImport.update({
  id: '/projects/$project/scope',
  path: '/projects/$project/scope',
  getParentRoute: () => AppRoute,
} as any)
const AppProposalsProposalAnalyticsRoute =
  AppProposalsProposalAnalyticsRouteImport.update({
    id: '/proposals/$proposal/analytics',
    path: '/proposals/$proposal/analytics',
    getParentRoute: () => AppRoute,
  } as any)
const AppProposalsProposalEditRoute =
  AppProposalsProposalEditRouteImport.update({
    id: '/proposals/$proposal/edit',
    path: '/proposals/$proposal/edit',
    getParentRoute: () => AppRoute,
  } as any)
const AppReportsClientsIndexRoute = AppReportsClientsIndexRouteImport.update({
  id: '/reports/clients/',
  path: '/reports/clients/',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsClientsClientRoute = AppReportsClientsClientRouteImport.update({
  id: '/reports/clients/$client',
  path: '/reports/clients/$client',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsPresentReportRoute = AppReportsPresentReportRouteImport.update({
  id: '/reports/present/$report',
  path: '/reports/present/$report',
  getParentRoute: () => AppRoute,
} as any)
const AppReviewsClientQuarterRoute = AppReviewsClientQuarterRouteImport.update({
  id: '/reviews/$client/$quarter',
  path: '/reviews/$client/$quarter',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsGroupPageRoute = AppSettingsGroupPageRouteImport.update({
  id: '/settings/$group/$page',
  path: '/settings/$group/$page',
  getParentRoute: () => AppRoute,
} as any)
const AppTemplatesKindTemplateRoute =
  AppTemplatesKindTemplateRouteImport.update({
    id: '/templates/$kind/$template',
    path: '/templates/$kind/$template',
    getParentRoute: () => AppRoute,
  } as any)
const AppWorkTemplatesIndexRoute = AppWorkTemplatesIndexRouteImport.update({
  id: '/work/templates/',
  path: '/work/templates/',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkTemplatesTemplateRoute =
  AppWorkTemplatesTemplateRouteImport.update({
    id: '/work/templates/$template',
    path: '/work/templates/$template',
    getParentRoute: () => AppRoute,
  } as any)
const PBookManageTokenRoute = PBookManageTokenRouteImport.update({
  id: '/p/book/manage/$token',
  path: '/p/book/manage/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PReferralWsCodeRoute = PReferralWsCodeRouteImport.update({
  id: '/p/referral/$ws/$code',
  path: '/p/referral/$ws/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAutomationsWorkflowRunsRunRoute =
  AppAutomationsWorkflowRunsRunRouteImport.update({
    id: '/automations/$workflow/runs/$run',
    path: '/automations/$workflow/runs/$run',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/join': typeof JoinRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/trust': typeof TrustRoute
  '/$': typeof AppSplatRoute
  '/apps': typeof AppAppsRoute
  '/audiences': typeof AppAudiencesRoute
  '/expenses': typeof AppExpensesRoute
  '/feedback': typeof AppFeedbackRoute
  '/follows': typeof AppFollowsRoute
  '/goals': typeof AppGoalsRoute
  '/home': typeof AppHomeRoute
  '/portfolio': typeof AppPortfolioRoute
  '/purchases': typeof AppPurchasesRoute
  '/surveys': typeof AppSurveysRoute
  '/website': typeof AppWebsiteRoute
  '/workspaces': typeof AppWorkspacesRoute
  '/apply/$job': typeof ApplyJobRoute
  '/help/$slug': typeof HelpSlugRoute
  '/invite/$token': typeof InviteTokenRoute
  '/n/$token': typeof NTokenRoute
  '/portal/briefs': typeof PortalBriefsRoute
  '/portal/calendar': typeof PortalCalendarRoute
  '/portal/changes': typeof PortalChangesRoute
  '/portal/files': typeof PortalFilesRoute
  '/portal/forms': typeof PortalFormsRoute
  '/portal/help': typeof PortalHelpRoute
  '/portal/messages': typeof PortalMessagesRoute
  '/portal/money': typeof PortalMoneyRoute
  '/portal/plans': typeof PortalPlansRoute
  '/portal/reports': typeof PortalReportsRoute
  '/portal/requests': typeof PortalRequestsRoute
  '/portal/settings': typeof PortalSettingsRoute
  '/portal/sign-in': typeof PortalSignInRoute
  '/portal/social': typeof PortalSocialRoute
  '/portal/store': typeof PortalStoreRoute
  '/portal/tickets': typeof PortalTicketsRoute
  '/portal/welcome': typeof PortalWelcomeRoute
  '/r/$token': typeof RTokenRoute
  '/setup/$step': typeof SetupStepRoute
  '/freelancer/': typeof FreelancerIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/agreements/$agreement': typeof AppAgreementsAgreementRoute
  '/agreements/id-reviews': typeof AppAgreementsIdReviewsRoute
  '/automations/map': typeof AppAutomationsMapRoute
  '/automations/n8n': typeof AppAutomationsN8nRoute
  '/automations/runs': typeof AppAutomationsRunsRoute
  '/automations/templates': typeof AppAutomationsTemplatesRoute
  '/budgets/$tab': typeof AppBudgetsTabRoute
  '/calendar/overlap': typeof AppCalendarOverlapRoute
  '/calls/playlists': typeof AppCallsPlaylistsRoute
  '/campaigns/$campaign': typeof AppCampaignsCampaignRoute
  '/catalogue/$tab': typeof AppCatalogueTabRoute
  '/catalogue/store': typeof AppCatalogueStoreRoute
  '/chat/$channel': typeof AppChatChannelRoute
  '/clients/duplicates': typeof AppClientsDuplicatesRoute
  '/contacts/$contact': typeof AppContactsContactRoute
  '/cycles/$cycle': typeof AppCyclesCycleRoute
  '/dashboards/$dashboard': typeof AppDashboardsDashboardRoute
  '/deals/$deal': typeof AppDealsDealRoute
  '/deals/follow-ups': typeof AppDealsFollowUpsRoute
  '/docs/$doc': typeof AppDocsDocRoute
  '/files/$folder': typeof AppFilesFolderRoute
  '/files/storage': typeof AppFilesStorageRoute
  '/files/trash': typeof AppFilesTrashRoute
  '/finance/$tab': typeof AppFinanceTabRoute
  '/freelancers/$freelancer': typeof AppFreelancersFreelancerRoute
  '/freelancers/payouts': typeof AppFreelancersPayoutsRoute
  '/freelancers/requisitions': typeof AppFreelancersRequisitionsRoute
  '/hiring/$job': typeof AppHiringJobRoute
  '/import/$type': typeof AppImportTypeRoute
  '/inbox/$thread': typeof AppInboxThreadRoute
  '/inbox/whatsapp-templates': typeof AppInboxWhatsappTemplatesRoute
  '/initiatives/$initiative': typeof AppInitiativesInitiativeRoute
  '/invoices/$invoice': typeof AppInvoicesInvoiceRoute
  '/invoices/aging': typeof AppInvoicesAgingRoute
  '/lab/$family': typeof AppLabFamilyRoute
  '/meetings/$meeting': typeof AppMeetingsMeetingRoute
  '/onboarding/$run': typeof AppOnboardingRunRoute
  '/one-on-ones/$person': typeof AppOneOnOnesPersonRoute
  '/outreach/$sequence': typeof AppOutreachSequenceRoute
  '/outreach/deliverability': typeof AppOutreachDeliverabilityRoute
  '/outreach/lists': typeof AppOutreachListsRoute
  '/outreach/mailboxes': typeof AppOutreachMailboxesRoute
  '/outreach/warmup': typeof AppOutreachWarmupRoute
  '/portfolios/$portfolio': typeof AppPortfoliosPortfolioRoute
  '/proofs/$proof': typeof AppProofsProofRoute
  '/proposals/templates': typeof AppProposalsTemplatesRoute
  '/queues/$role': typeof AppQueuesRoleRoute
  '/reports/$report': typeof AppReportsReportRoute
  '/reports/attribution': typeof AppReportsAttributionRoute
  '/reports/revenue-analytics': typeof AppReportsRevenueAnalyticsRoute
  '/reports/targets': typeof AppReportsTargetsRoute
  '/sales/rep': typeof AppSalesRepRoute
  '/sales/rules': typeof AppSalesRulesRoute
  '/spaces/$space': typeof AppSpacesSpaceRoute
  '/subscriptions/$subscription': typeof AppSubscriptionsSubscriptionRoute
  '/subscriptions/recurring': typeof AppSubscriptionsRecurringRoute
  '/tasks/$key': typeof AppTasksKeyRoute
  '/team/$member': typeof AppTeamMemberRoute
  '/tickets/$ticket': typeof AppTicketsTicketRoute
  '/time/approvals': typeof AppTimeApprovalsRoute
  '/time/ledger': typeof AppTimeLedgerRoute
  '/time/timer': typeof AppTimeTimerRoute
  '/tours/stuck': typeof AppToursStuckRoute
  '/whiteboards/$id': typeof AppWhiteboardsIdRoute
  '/p/action/$token': typeof PActionTokenRoute
  '/p/book/$slug': typeof PBookSlugRoute
  '/p/form/$slug': typeof PFormSlugRoute
  '/p/freelancer/$token': typeof PFreelancerTokenRoute
  '/p/help/$slug': typeof PHelpSlugRoute
  '/p/pay/$token': typeof PPayTokenRoute
  '/p/proposal/$token': typeof PProposalTokenRoute
  '/p/share/$token': typeof PShareTokenRoute
  '/p/sign/$token': typeof PSignTokenRoute
  '/p/survey/$token': typeof PSurveyTokenRoute
  '/p/testimonial/$token': typeof PTestimonialTokenRoute
  '/p/unsubscribe/$token': typeof PUnsubscribeTokenRoute
  '/p/upload/$token': typeof PUploadTokenRoute
  '/portal/approvals/$approval': typeof PortalApprovalsApprovalRoute
  '/portal/apps/$tab': typeof PortalAppsTabRoute
  '/portal/projects/$project': typeof PortalProjectsProjectRoute
  '/agreements/': typeof AppAgreementsIndexRoute
  '/approvals/': typeof AppApprovalsIndexRoute
  '/assets/': typeof AppAssetsIndexRoute
  '/automations/': typeof AppAutomationsIndexRoute
  '/bookings/': typeof AppBookingsIndexRoute
  '/budgets/': typeof AppBudgetsIndexRoute
  '/calendar/': typeof AppCalendarIndexRoute
  '/calls/': typeof AppCallsIndexRoute
  '/campaigns/': typeof AppCampaignsIndexRoute
  '/chat/': typeof AppChatIndexRoute
  '/clients/': typeof AppClientsIndexRoute
  '/contacts/': typeof AppContactsIndexRoute
  '/cycles/': typeof AppCyclesIndexRoute
  '/dashboards/': typeof AppDashboardsIndexRoute
  '/deals/': typeof AppDealsIndexRoute
  '/docs/': typeof AppDocsIndexRoute
  '/files/': typeof AppFilesIndexRoute
  '/forms/': typeof AppFormsIndexRoute
  '/freelancers/': typeof AppFreelancersIndexRoute
  '/getting-started/': typeof AppGettingStartedIndexRoute
  '/help-centre/': typeof AppHelpCentreIndexRoute
  '/hiring/': typeof AppHiringIndexRoute
  '/inbox/': typeof AppInboxIndexRoute
  '/initiatives/': typeof AppInitiativesIndexRoute
  '/invoices/': typeof AppInvoicesIndexRoute
  '/leaderboard/': typeof AppLeaderboardIndexRoute
  '/meetings/': typeof AppMeetingsIndexRoute
  '/my-work/': typeof AppMyWorkIndexRoute
  '/notifications/': typeof AppNotificationsIndexRoute
  '/o/': typeof AppOIndexRoute
  '/onboarding/': typeof AppOnboardingIndexRoute
  '/outreach/': typeof AppOutreachIndexRoute
  '/payments/': typeof AppPaymentsIndexRoute
  '/policies/': typeof AppPoliciesIndexRoute
  '/portfolios/': typeof AppPortfoliosIndexRoute
  '/presets/': typeof AppPresetsIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/proofs/': typeof AppProofsIndexRoute
  '/proposals/': typeof AppProposalsIndexRoute
  '/queues/': typeof AppQueuesIndexRoute
  '/reports/': typeof AppReportsIndexRoute
  '/reviews/': typeof AppReviewsIndexRoute
  '/sales/': typeof AppSalesIndexRoute
  '/schedule/': typeof AppScheduleIndexRoute
  '/search/': typeof AppSearchIndexRoute
  '/social/': typeof AppSocialIndexRoute
  '/subscriptions/': typeof AppSubscriptionsIndexRoute
  '/team/': typeof AppTeamIndexRoute
  '/tickets/': typeof AppTicketsIndexRoute
  '/time-off/': typeof AppTimeOffIndexRoute
  '/time/': typeof AppTimeIndexRoute
  '/tours/': typeof AppToursIndexRoute
  '/triage/': typeof AppTriageIndexRoute
  '/updates/': typeof AppUpdatesIndexRoute
  '/vault/': typeof AppVaultIndexRoute
  '/web-feedback/': typeof AppWebFeedbackIndexRoute
  '/portal/approvals/': typeof PortalApprovalsIndexRoute
  '/portal/projects/': typeof PortalProjectsIndexRoute
  '/automations/messages/$template': typeof AppAutomationsMessagesTemplateRoute
  '/bookings/pages/$page': typeof AppBookingsPagesPageRoute
  '/clients/$client/$tab': typeof AppClientsClientTabRoute
  '/clients/$client/lifecycle': typeof AppClientsClientLifecycleRoute
  '/dashboards/template/$template': typeof AppDashboardsTemplateTemplateRoute
  '/files/$file/office': typeof AppFilesFileOfficeRoute
  '/forms/$form/analytics': typeof AppFormsFormAnalyticsRoute
  '/forms/$form/edit': typeof AppFormsFormEditRoute
  '/forms/$form/responses': typeof AppFormsFormResponsesRoute
  '/my-work/lists/$list': typeof AppMyWorkListsListRoute
  '/o/$object/$id': typeof AppOObjectIdRoute
  '/onboarding/templates/$template': typeof AppOnboardingTemplatesTemplateRoute
  '/projects/$project/$tab': typeof AppProjectsProjectTabRoute
  '/projects/$project/scope': typeof AppProjectsProjectScopeRoute
  '/proposals/$proposal/analytics': typeof AppProposalsProposalAnalyticsRoute
  '/proposals/$proposal/edit': typeof AppProposalsProposalEditRoute
  '/reports/clients/$client': typeof AppReportsClientsClientRoute
  '/reports/present/$report': typeof AppReportsPresentReportRoute
  '/reviews/$client/$quarter': typeof AppReviewsClientQuarterRoute
  '/settings/$group/$page': typeof AppSettingsGroupPageRoute
  '/templates/$kind/$template': typeof AppTemplatesKindTemplateRoute
  '/work/templates/$template': typeof AppWorkTemplatesTemplateRoute
  '/p/book/manage/$token': typeof PBookManageTokenRoute
  '/p/referral/$ws/$code': typeof PReferralWsCodeRoute
  '/automations/$workflow/': typeof AppAutomationsWorkflowIndexRoute
  '/automations/messages/': typeof AppAutomationsMessagesIndexRoute
  '/o/$object/': typeof AppOObjectIndexRoute
  '/reports/clients/': typeof AppReportsClientsIndexRoute
  '/work/templates/': typeof AppWorkTemplatesIndexRoute
  '/automations/$workflow/runs/$run': typeof AppAutomationsWorkflowRunsRunRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/join': typeof JoinRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/trust': typeof TrustRoute
  '/$': typeof AppSplatRoute
  '/apps': typeof AppAppsRoute
  '/audiences': typeof AppAudiencesRoute
  '/expenses': typeof AppExpensesRoute
  '/feedback': typeof AppFeedbackRoute
  '/follows': typeof AppFollowsRoute
  '/goals': typeof AppGoalsRoute
  '/home': typeof AppHomeRoute
  '/portfolio': typeof AppPortfolioRoute
  '/purchases': typeof AppPurchasesRoute
  '/surveys': typeof AppSurveysRoute
  '/website': typeof AppWebsiteRoute
  '/workspaces': typeof AppWorkspacesRoute
  '/apply/$job': typeof ApplyJobRoute
  '/help/$slug': typeof HelpSlugRoute
  '/invite/$token': typeof InviteTokenRoute
  '/n/$token': typeof NTokenRoute
  '/portal/briefs': typeof PortalBriefsRoute
  '/portal/calendar': typeof PortalCalendarRoute
  '/portal/changes': typeof PortalChangesRoute
  '/portal/files': typeof PortalFilesRoute
  '/portal/forms': typeof PortalFormsRoute
  '/portal/help': typeof PortalHelpRoute
  '/portal/messages': typeof PortalMessagesRoute
  '/portal/money': typeof PortalMoneyRoute
  '/portal/plans': typeof PortalPlansRoute
  '/portal/reports': typeof PortalReportsRoute
  '/portal/requests': typeof PortalRequestsRoute
  '/portal/settings': typeof PortalSettingsRoute
  '/portal/sign-in': typeof PortalSignInRoute
  '/portal/social': typeof PortalSocialRoute
  '/portal/store': typeof PortalStoreRoute
  '/portal/tickets': typeof PortalTicketsRoute
  '/portal/welcome': typeof PortalWelcomeRoute
  '/r/$token': typeof RTokenRoute
  '/setup/$step': typeof SetupStepRoute
  '/freelancer': typeof FreelancerIndexRoute
  '/portal': typeof PortalIndexRoute
  '/agreements/$agreement': typeof AppAgreementsAgreementRoute
  '/agreements/id-reviews': typeof AppAgreementsIdReviewsRoute
  '/automations/map': typeof AppAutomationsMapRoute
  '/automations/n8n': typeof AppAutomationsN8nRoute
  '/automations/runs': typeof AppAutomationsRunsRoute
  '/automations/templates': typeof AppAutomationsTemplatesRoute
  '/budgets/$tab': typeof AppBudgetsTabRoute
  '/calendar/overlap': typeof AppCalendarOverlapRoute
  '/calls/playlists': typeof AppCallsPlaylistsRoute
  '/campaigns/$campaign': typeof AppCampaignsCampaignRoute
  '/catalogue/$tab': typeof AppCatalogueTabRoute
  '/catalogue/store': typeof AppCatalogueStoreRoute
  '/chat/$channel': typeof AppChatChannelRoute
  '/clients/duplicates': typeof AppClientsDuplicatesRoute
  '/contacts/$contact': typeof AppContactsContactRoute
  '/cycles/$cycle': typeof AppCyclesCycleRoute
  '/dashboards/$dashboard': typeof AppDashboardsDashboardRoute
  '/deals/$deal': typeof AppDealsDealRoute
  '/deals/follow-ups': typeof AppDealsFollowUpsRoute
  '/docs/$doc': typeof AppDocsDocRoute
  '/files/$folder': typeof AppFilesFolderRoute
  '/files/storage': typeof AppFilesStorageRoute
  '/files/trash': typeof AppFilesTrashRoute
  '/finance/$tab': typeof AppFinanceTabRoute
  '/freelancers/$freelancer': typeof AppFreelancersFreelancerRoute
  '/freelancers/payouts': typeof AppFreelancersPayoutsRoute
  '/freelancers/requisitions': typeof AppFreelancersRequisitionsRoute
  '/hiring/$job': typeof AppHiringJobRoute
  '/import/$type': typeof AppImportTypeRoute
  '/inbox/$thread': typeof AppInboxThreadRoute
  '/inbox/whatsapp-templates': typeof AppInboxWhatsappTemplatesRoute
  '/initiatives/$initiative': typeof AppInitiativesInitiativeRoute
  '/invoices/$invoice': typeof AppInvoicesInvoiceRoute
  '/invoices/aging': typeof AppInvoicesAgingRoute
  '/lab/$family': typeof AppLabFamilyRoute
  '/meetings/$meeting': typeof AppMeetingsMeetingRoute
  '/onboarding/$run': typeof AppOnboardingRunRoute
  '/one-on-ones/$person': typeof AppOneOnOnesPersonRoute
  '/outreach/$sequence': typeof AppOutreachSequenceRoute
  '/outreach/deliverability': typeof AppOutreachDeliverabilityRoute
  '/outreach/lists': typeof AppOutreachListsRoute
  '/outreach/mailboxes': typeof AppOutreachMailboxesRoute
  '/outreach/warmup': typeof AppOutreachWarmupRoute
  '/portfolios/$portfolio': typeof AppPortfoliosPortfolioRoute
  '/proofs/$proof': typeof AppProofsProofRoute
  '/proposals/templates': typeof AppProposalsTemplatesRoute
  '/queues/$role': typeof AppQueuesRoleRoute
  '/reports/$report': typeof AppReportsReportRoute
  '/reports/attribution': typeof AppReportsAttributionRoute
  '/reports/revenue-analytics': typeof AppReportsRevenueAnalyticsRoute
  '/reports/targets': typeof AppReportsTargetsRoute
  '/sales/rep': typeof AppSalesRepRoute
  '/sales/rules': typeof AppSalesRulesRoute
  '/spaces/$space': typeof AppSpacesSpaceRoute
  '/subscriptions/$subscription': typeof AppSubscriptionsSubscriptionRoute
  '/subscriptions/recurring': typeof AppSubscriptionsRecurringRoute
  '/tasks/$key': typeof AppTasksKeyRoute
  '/team/$member': typeof AppTeamMemberRoute
  '/tickets/$ticket': typeof AppTicketsTicketRoute
  '/time/approvals': typeof AppTimeApprovalsRoute
  '/time/ledger': typeof AppTimeLedgerRoute
  '/time/timer': typeof AppTimeTimerRoute
  '/tours/stuck': typeof AppToursStuckRoute
  '/whiteboards/$id': typeof AppWhiteboardsIdRoute
  '/p/action/$token': typeof PActionTokenRoute
  '/p/book/$slug': typeof PBookSlugRoute
  '/p/form/$slug': typeof PFormSlugRoute
  '/p/freelancer/$token': typeof PFreelancerTokenRoute
  '/p/help/$slug': typeof PHelpSlugRoute
  '/p/pay/$token': typeof PPayTokenRoute
  '/p/proposal/$token': typeof PProposalTokenRoute
  '/p/share/$token': typeof PShareTokenRoute
  '/p/sign/$token': typeof PSignTokenRoute
  '/p/survey/$token': typeof PSurveyTokenRoute
  '/p/testimonial/$token': typeof PTestimonialTokenRoute
  '/p/unsubscribe/$token': typeof PUnsubscribeTokenRoute
  '/p/upload/$token': typeof PUploadTokenRoute
  '/portal/approvals/$approval': typeof PortalApprovalsApprovalRoute
  '/portal/apps/$tab': typeof PortalAppsTabRoute
  '/portal/projects/$project': typeof PortalProjectsProjectRoute
  '/agreements': typeof AppAgreementsIndexRoute
  '/approvals': typeof AppApprovalsIndexRoute
  '/assets': typeof AppAssetsIndexRoute
  '/automations': typeof AppAutomationsIndexRoute
  '/bookings': typeof AppBookingsIndexRoute
  '/budgets': typeof AppBudgetsIndexRoute
  '/calendar': typeof AppCalendarIndexRoute
  '/calls': typeof AppCallsIndexRoute
  '/campaigns': typeof AppCampaignsIndexRoute
  '/chat': typeof AppChatIndexRoute
  '/clients': typeof AppClientsIndexRoute
  '/contacts': typeof AppContactsIndexRoute
  '/cycles': typeof AppCyclesIndexRoute
  '/dashboards': typeof AppDashboardsIndexRoute
  '/deals': typeof AppDealsIndexRoute
  '/docs': typeof AppDocsIndexRoute
  '/files': typeof AppFilesIndexRoute
  '/forms': typeof AppFormsIndexRoute
  '/freelancers': typeof AppFreelancersIndexRoute
  '/getting-started': typeof AppGettingStartedIndexRoute
  '/help-centre': typeof AppHelpCentreIndexRoute
  '/hiring': typeof AppHiringIndexRoute
  '/inbox': typeof AppInboxIndexRoute
  '/initiatives': typeof AppInitiativesIndexRoute
  '/invoices': typeof AppInvoicesIndexRoute
  '/leaderboard': typeof AppLeaderboardIndexRoute
  '/meetings': typeof AppMeetingsIndexRoute
  '/my-work': typeof AppMyWorkIndexRoute
  '/notifications': typeof AppNotificationsIndexRoute
  '/o': typeof AppOIndexRoute
  '/onboarding': typeof AppOnboardingIndexRoute
  '/outreach': typeof AppOutreachIndexRoute
  '/payments': typeof AppPaymentsIndexRoute
  '/policies': typeof AppPoliciesIndexRoute
  '/portfolios': typeof AppPortfoliosIndexRoute
  '/presets': typeof AppPresetsIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/proofs': typeof AppProofsIndexRoute
  '/proposals': typeof AppProposalsIndexRoute
  '/queues': typeof AppQueuesIndexRoute
  '/reports': typeof AppReportsIndexRoute
  '/reviews': typeof AppReviewsIndexRoute
  '/sales': typeof AppSalesIndexRoute
  '/schedule': typeof AppScheduleIndexRoute
  '/search': typeof AppSearchIndexRoute
  '/social': typeof AppSocialIndexRoute
  '/subscriptions': typeof AppSubscriptionsIndexRoute
  '/team': typeof AppTeamIndexRoute
  '/tickets': typeof AppTicketsIndexRoute
  '/time-off': typeof AppTimeOffIndexRoute
  '/time': typeof AppTimeIndexRoute
  '/tours': typeof AppToursIndexRoute
  '/triage': typeof AppTriageIndexRoute
  '/updates': typeof AppUpdatesIndexRoute
  '/vault': typeof AppVaultIndexRoute
  '/web-feedback': typeof AppWebFeedbackIndexRoute
  '/portal/approvals': typeof PortalApprovalsIndexRoute
  '/portal/projects': typeof PortalProjectsIndexRoute
  '/automations/messages/$template': typeof AppAutomationsMessagesTemplateRoute
  '/bookings/pages/$page': typeof AppBookingsPagesPageRoute
  '/clients/$client/$tab': typeof AppClientsClientTabRoute
  '/clients/$client/lifecycle': typeof AppClientsClientLifecycleRoute
  '/dashboards/template/$template': typeof AppDashboardsTemplateTemplateRoute
  '/files/$file/office': typeof AppFilesFileOfficeRoute
  '/forms/$form/analytics': typeof AppFormsFormAnalyticsRoute
  '/forms/$form/edit': typeof AppFormsFormEditRoute
  '/forms/$form/responses': typeof AppFormsFormResponsesRoute
  '/my-work/lists/$list': typeof AppMyWorkListsListRoute
  '/o/$object/$id': typeof AppOObjectIdRoute
  '/onboarding/templates/$template': typeof AppOnboardingTemplatesTemplateRoute
  '/projects/$project/$tab': typeof AppProjectsProjectTabRoute
  '/projects/$project/scope': typeof AppProjectsProjectScopeRoute
  '/proposals/$proposal/analytics': typeof AppProposalsProposalAnalyticsRoute
  '/proposals/$proposal/edit': typeof AppProposalsProposalEditRoute
  '/reports/clients/$client': typeof AppReportsClientsClientRoute
  '/reports/present/$report': typeof AppReportsPresentReportRoute
  '/reviews/$client/$quarter': typeof AppReviewsClientQuarterRoute
  '/settings/$group/$page': typeof AppSettingsGroupPageRoute
  '/templates/$kind/$template': typeof AppTemplatesKindTemplateRoute
  '/work/templates/$template': typeof AppWorkTemplatesTemplateRoute
  '/p/book/manage/$token': typeof PBookManageTokenRoute
  '/p/referral/$ws/$code': typeof PReferralWsCodeRoute
  '/automations/$workflow': typeof AppAutomationsWorkflowIndexRoute
  '/automations/messages': typeof AppAutomationsMessagesIndexRoute
  '/o/$object': typeof AppOObjectIndexRoute
  '/reports/clients': typeof AppReportsClientsIndexRoute
  '/work/templates': typeof AppWorkTemplatesIndexRoute
  '/automations/$workflow/runs/$run': typeof AppAutomationsWorkflowRunsRunRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/join': typeof JoinRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/trust': typeof TrustRoute
  '/_app/$': typeof AppSplatRoute
  '/_app/apps': typeof AppAppsRoute
  '/_app/audiences': typeof AppAudiencesRoute
  '/_app/expenses': typeof AppExpensesRoute
  '/_app/feedback': typeof AppFeedbackRoute
  '/_app/follows': typeof AppFollowsRoute
  '/_app/goals': typeof AppGoalsRoute
  '/_app/home': typeof AppHomeRoute
  '/_app/portfolio': typeof AppPortfolioRoute
  '/_app/purchases': typeof AppPurchasesRoute
  '/_app/surveys': typeof AppSurveysRoute
  '/_app/website': typeof AppWebsiteRoute
  '/_app/workspaces': typeof AppWorkspacesRoute
  '/apply/$job': typeof ApplyJobRoute
  '/help/$slug': typeof HelpSlugRoute
  '/invite/$token': typeof InviteTokenRoute
  '/n/$token': typeof NTokenRoute
  '/portal/briefs': typeof PortalBriefsRoute
  '/portal/calendar': typeof PortalCalendarRoute
  '/portal/changes': typeof PortalChangesRoute
  '/portal/files': typeof PortalFilesRoute
  '/portal/forms': typeof PortalFormsRoute
  '/portal/help': typeof PortalHelpRoute
  '/portal/messages': typeof PortalMessagesRoute
  '/portal/money': typeof PortalMoneyRoute
  '/portal/plans': typeof PortalPlansRoute
  '/portal/reports': typeof PortalReportsRoute
  '/portal/requests': typeof PortalRequestsRoute
  '/portal/settings': typeof PortalSettingsRoute
  '/portal/sign-in': typeof PortalSignInRoute
  '/portal/social': typeof PortalSocialRoute
  '/portal/store': typeof PortalStoreRoute
  '/portal/tickets': typeof PortalTicketsRoute
  '/portal/welcome': typeof PortalWelcomeRoute
  '/r/$token': typeof RTokenRoute
  '/setup/$step': typeof SetupStepRoute
  '/freelancer/': typeof FreelancerIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/_app/agreements/$agreement': typeof AppAgreementsAgreementRoute
  '/_app/agreements/id-reviews': typeof AppAgreementsIdReviewsRoute
  '/_app/automations/map': typeof AppAutomationsMapRoute
  '/_app/automations/n8n': typeof AppAutomationsN8nRoute
  '/_app/automations/runs': typeof AppAutomationsRunsRoute
  '/_app/automations/templates': typeof AppAutomationsTemplatesRoute
  '/_app/budgets/$tab': typeof AppBudgetsTabRoute
  '/_app/calendar/overlap': typeof AppCalendarOverlapRoute
  '/_app/calls/playlists': typeof AppCallsPlaylistsRoute
  '/_app/campaigns/$campaign': typeof AppCampaignsCampaignRoute
  '/_app/catalogue/$tab': typeof AppCatalogueTabRoute
  '/_app/catalogue/store': typeof AppCatalogueStoreRoute
  '/_app/chat/$channel': typeof AppChatChannelRoute
  '/_app/clients/duplicates': typeof AppClientsDuplicatesRoute
  '/_app/contacts/$contact': typeof AppContactsContactRoute
  '/_app/cycles/$cycle': typeof AppCyclesCycleRoute
  '/_app/dashboards/$dashboard': typeof AppDashboardsDashboardRoute
  '/_app/deals/$deal': typeof AppDealsDealRoute
  '/_app/deals/follow-ups': typeof AppDealsFollowUpsRoute
  '/_app/docs/$doc': typeof AppDocsDocRoute
  '/_app/files/$folder': typeof AppFilesFolderRoute
  '/_app/files/storage': typeof AppFilesStorageRoute
  '/_app/files/trash': typeof AppFilesTrashRoute
  '/_app/finance/$tab': typeof AppFinanceTabRoute
  '/_app/freelancers/$freelancer': typeof AppFreelancersFreelancerRoute
  '/_app/freelancers/payouts': typeof AppFreelancersPayoutsRoute
  '/_app/freelancers/requisitions': typeof AppFreelancersRequisitionsRoute
  '/_app/hiring/$job': typeof AppHiringJobRoute
  '/_app/import/$type': typeof AppImportTypeRoute
  '/_app/inbox/$thread': typeof AppInboxThreadRoute
  '/_app/inbox/whatsapp-templates': typeof AppInboxWhatsappTemplatesRoute
  '/_app/initiatives/$initiative': typeof AppInitiativesInitiativeRoute
  '/_app/invoices/$invoice': typeof AppInvoicesInvoiceRoute
  '/_app/invoices/aging': typeof AppInvoicesAgingRoute
  '/_app/lab/$family': typeof AppLabFamilyRoute
  '/_app/meetings/$meeting': typeof AppMeetingsMeetingRoute
  '/_app/onboarding/$run': typeof AppOnboardingRunRoute
  '/_app/one-on-ones/$person': typeof AppOneOnOnesPersonRoute
  '/_app/outreach/$sequence': typeof AppOutreachSequenceRoute
  '/_app/outreach/deliverability': typeof AppOutreachDeliverabilityRoute
  '/_app/outreach/lists': typeof AppOutreachListsRoute
  '/_app/outreach/mailboxes': typeof AppOutreachMailboxesRoute
  '/_app/outreach/warmup': typeof AppOutreachWarmupRoute
  '/_app/portfolios/$portfolio': typeof AppPortfoliosPortfolioRoute
  '/_app/proofs/$proof': typeof AppProofsProofRoute
  '/_app/proposals/templates': typeof AppProposalsTemplatesRoute
  '/_app/queues/$role': typeof AppQueuesRoleRoute
  '/_app/reports/$report': typeof AppReportsReportRoute
  '/_app/reports/attribution': typeof AppReportsAttributionRoute
  '/_app/reports/revenue-analytics': typeof AppReportsRevenueAnalyticsRoute
  '/_app/reports/targets': typeof AppReportsTargetsRoute
  '/_app/sales/rep': typeof AppSalesRepRoute
  '/_app/sales/rules': typeof AppSalesRulesRoute
  '/_app/spaces/$space': typeof AppSpacesSpaceRoute
  '/_app/subscriptions/$subscription': typeof AppSubscriptionsSubscriptionRoute
  '/_app/subscriptions/recurring': typeof AppSubscriptionsRecurringRoute
  '/_app/tasks/$key': typeof AppTasksKeyRoute
  '/_app/team/$member': typeof AppTeamMemberRoute
  '/_app/tickets/$ticket': typeof AppTicketsTicketRoute
  '/_app/time/approvals': typeof AppTimeApprovalsRoute
  '/_app/time/ledger': typeof AppTimeLedgerRoute
  '/_app/time/timer': typeof AppTimeTimerRoute
  '/_app/tours/stuck': typeof AppToursStuckRoute
  '/_app/whiteboards/$id': typeof AppWhiteboardsIdRoute
  '/p/action/$token': typeof PActionTokenRoute
  '/p/book/$slug': typeof PBookSlugRoute
  '/p/form/$slug': typeof PFormSlugRoute
  '/p/freelancer/$token': typeof PFreelancerTokenRoute
  '/p/help/$slug': typeof PHelpSlugRoute
  '/p/pay/$token': typeof PPayTokenRoute
  '/p/proposal/$token': typeof PProposalTokenRoute
  '/p/share/$token': typeof PShareTokenRoute
  '/p/sign/$token': typeof PSignTokenRoute
  '/p/survey/$token': typeof PSurveyTokenRoute
  '/p/testimonial/$token': typeof PTestimonialTokenRoute
  '/p/unsubscribe/$token': typeof PUnsubscribeTokenRoute
  '/p/upload/$token': typeof PUploadTokenRoute
  '/portal/approvals/$approval': typeof PortalApprovalsApprovalRoute
  '/portal/apps/$tab': typeof PortalAppsTabRoute
  '/portal/projects/$project': typeof PortalProjectsProjectRoute
  '/_app/agreements/': typeof AppAgreementsIndexRoute
  '/_app/approvals/': typeof AppApprovalsIndexRoute
  '/_app/assets/': typeof AppAssetsIndexRoute
  '/_app/automations/': typeof AppAutomationsIndexRoute
  '/_app/bookings/': typeof AppBookingsIndexRoute
  '/_app/budgets/': typeof AppBudgetsIndexRoute
  '/_app/calendar/': typeof AppCalendarIndexRoute
  '/_app/calls/': typeof AppCallsIndexRoute
  '/_app/campaigns/': typeof AppCampaignsIndexRoute
  '/_app/chat/': typeof AppChatIndexRoute
  '/_app/clients/': typeof AppClientsIndexRoute
  '/_app/contacts/': typeof AppContactsIndexRoute
  '/_app/cycles/': typeof AppCyclesIndexRoute
  '/_app/dashboards/': typeof AppDashboardsIndexRoute
  '/_app/deals/': typeof AppDealsIndexRoute
  '/_app/docs/': typeof AppDocsIndexRoute
  '/_app/files/': typeof AppFilesIndexRoute
  '/_app/forms/': typeof AppFormsIndexRoute
  '/_app/freelancers/': typeof AppFreelancersIndexRoute
  '/_app/getting-started/': typeof AppGettingStartedIndexRoute
  '/_app/help-centre/': typeof AppHelpCentreIndexRoute
  '/_app/hiring/': typeof AppHiringIndexRoute
  '/_app/inbox/': typeof AppInboxIndexRoute
  '/_app/initiatives/': typeof AppInitiativesIndexRoute
  '/_app/invoices/': typeof AppInvoicesIndexRoute
  '/_app/leaderboard/': typeof AppLeaderboardIndexRoute
  '/_app/meetings/': typeof AppMeetingsIndexRoute
  '/_app/my-work/': typeof AppMyWorkIndexRoute
  '/_app/notifications/': typeof AppNotificationsIndexRoute
  '/_app/o/': typeof AppOIndexRoute
  '/_app/onboarding/': typeof AppOnboardingIndexRoute
  '/_app/outreach/': typeof AppOutreachIndexRoute
  '/_app/payments/': typeof AppPaymentsIndexRoute
  '/_app/policies/': typeof AppPoliciesIndexRoute
  '/_app/portfolios/': typeof AppPortfoliosIndexRoute
  '/_app/presets/': typeof AppPresetsIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/proofs/': typeof AppProofsIndexRoute
  '/_app/proposals/': typeof AppProposalsIndexRoute
  '/_app/queues/': typeof AppQueuesIndexRoute
  '/_app/reports/': typeof AppReportsIndexRoute
  '/_app/reviews/': typeof AppReviewsIndexRoute
  '/_app/sales/': typeof AppSalesIndexRoute
  '/_app/schedule/': typeof AppScheduleIndexRoute
  '/_app/search/': typeof AppSearchIndexRoute
  '/_app/social/': typeof AppSocialIndexRoute
  '/_app/subscriptions/': typeof AppSubscriptionsIndexRoute
  '/_app/team/': typeof AppTeamIndexRoute
  '/_app/tickets/': typeof AppTicketsIndexRoute
  '/_app/time-off/': typeof AppTimeOffIndexRoute
  '/_app/time/': typeof AppTimeIndexRoute
  '/_app/tours/': typeof AppToursIndexRoute
  '/_app/triage/': typeof AppTriageIndexRoute
  '/_app/updates/': typeof AppUpdatesIndexRoute
  '/_app/vault/': typeof AppVaultIndexRoute
  '/_app/web-feedback/': typeof AppWebFeedbackIndexRoute
  '/portal/approvals/': typeof PortalApprovalsIndexRoute
  '/portal/projects/': typeof PortalProjectsIndexRoute
  '/_app/automations/messages/$template': typeof AppAutomationsMessagesTemplateRoute
  '/_app/bookings/pages/$page': typeof AppBookingsPagesPageRoute
  '/_app/clients/$client/$tab': typeof AppClientsClientTabRoute
  '/_app/clients/$client/lifecycle': typeof AppClientsClientLifecycleRoute
  '/_app/dashboards/template/$template': typeof AppDashboardsTemplateTemplateRoute
  '/_app/files/$file/office': typeof AppFilesFileOfficeRoute
  '/_app/forms/$form/analytics': typeof AppFormsFormAnalyticsRoute
  '/_app/forms/$form/edit': typeof AppFormsFormEditRoute
  '/_app/forms/$form/responses': typeof AppFormsFormResponsesRoute
  '/_app/my-work/lists/$list': typeof AppMyWorkListsListRoute
  '/_app/o/$object/$id': typeof AppOObjectIdRoute
  '/_app/onboarding/templates/$template': typeof AppOnboardingTemplatesTemplateRoute
  '/_app/projects/$project/$tab': typeof AppProjectsProjectTabRoute
  '/_app/projects/$project/scope': typeof AppProjectsProjectScopeRoute
  '/_app/proposals/$proposal/analytics': typeof AppProposalsProposalAnalyticsRoute
  '/_app/proposals/$proposal/edit': typeof AppProposalsProposalEditRoute
  '/_app/reports/clients/$client': typeof AppReportsClientsClientRoute
  '/_app/reports/present/$report': typeof AppReportsPresentReportRoute
  '/_app/reviews/$client/$quarter': typeof AppReviewsClientQuarterRoute
  '/_app/settings/$group/$page': typeof AppSettingsGroupPageRoute
  '/_app/templates/$kind/$template': typeof AppTemplatesKindTemplateRoute
  '/_app/work/templates/$template': typeof AppWorkTemplatesTemplateRoute
  '/p/book/manage/$token': typeof PBookManageTokenRoute
  '/p/referral/$ws/$code': typeof PReferralWsCodeRoute
  '/_app/automations/$workflow/': typeof AppAutomationsWorkflowIndexRoute
  '/_app/automations/messages/': typeof AppAutomationsMessagesIndexRoute
  '/_app/o/$object/': typeof AppOObjectIndexRoute
  '/_app/reports/clients/': typeof AppReportsClientsIndexRoute
  '/_app/work/templates/': typeof AppWorkTemplatesIndexRoute
  '/_app/automations/$workflow/runs/$run': typeof AppAutomationsWorkflowRunsRunRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/join'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/trust'
    | '/$'
    | '/apps'
    | '/audiences'
    | '/expenses'
    | '/feedback'
    | '/follows'
    | '/goals'
    | '/home'
    | '/portfolio'
    | '/purchases'
    | '/surveys'
    | '/website'
    | '/workspaces'
    | '/apply/$job'
    | '/help/$slug'
    | '/invite/$token'
    | '/n/$token'
    | '/portal/briefs'
    | '/portal/calendar'
    | '/portal/changes'
    | '/portal/files'
    | '/portal/forms'
    | '/portal/help'
    | '/portal/messages'
    | '/portal/money'
    | '/portal/plans'
    | '/portal/reports'
    | '/portal/requests'
    | '/portal/settings'
    | '/portal/sign-in'
    | '/portal/social'
    | '/portal/store'
    | '/portal/tickets'
    | '/portal/welcome'
    | '/r/$token'
    | '/setup/$step'
    | '/freelancer/'
    | '/portal/'
    | '/agreements/$agreement'
    | '/agreements/id-reviews'
    | '/automations/map'
    | '/automations/n8n'
    | '/automations/runs'
    | '/automations/templates'
    | '/budgets/$tab'
    | '/calendar/overlap'
    | '/calls/playlists'
    | '/campaigns/$campaign'
    | '/catalogue/$tab'
    | '/catalogue/store'
    | '/chat/$channel'
    | '/clients/duplicates'
    | '/contacts/$contact'
    | '/cycles/$cycle'
    | '/dashboards/$dashboard'
    | '/deals/$deal'
    | '/deals/follow-ups'
    | '/docs/$doc'
    | '/files/$folder'
    | '/files/storage'
    | '/files/trash'
    | '/finance/$tab'
    | '/freelancers/$freelancer'
    | '/freelancers/payouts'
    | '/freelancers/requisitions'
    | '/hiring/$job'
    | '/import/$type'
    | '/inbox/$thread'
    | '/inbox/whatsapp-templates'
    | '/initiatives/$initiative'
    | '/invoices/$invoice'
    | '/invoices/aging'
    | '/lab/$family'
    | '/meetings/$meeting'
    | '/onboarding/$run'
    | '/one-on-ones/$person'
    | '/outreach/$sequence'
    | '/outreach/deliverability'
    | '/outreach/lists'
    | '/outreach/mailboxes'
    | '/outreach/warmup'
    | '/portfolios/$portfolio'
    | '/proofs/$proof'
    | '/proposals/templates'
    | '/queues/$role'
    | '/reports/$report'
    | '/reports/attribution'
    | '/reports/revenue-analytics'
    | '/reports/targets'
    | '/sales/rep'
    | '/sales/rules'
    | '/spaces/$space'
    | '/subscriptions/$subscription'
    | '/subscriptions/recurring'
    | '/tasks/$key'
    | '/team/$member'
    | '/tickets/$ticket'
    | '/time/approvals'
    | '/time/ledger'
    | '/time/timer'
    | '/tours/stuck'
    | '/whiteboards/$id'
    | '/p/action/$token'
    | '/p/book/$slug'
    | '/p/form/$slug'
    | '/p/freelancer/$token'
    | '/p/help/$slug'
    | '/p/pay/$token'
    | '/p/proposal/$token'
    | '/p/share/$token'
    | '/p/sign/$token'
    | '/p/survey/$token'
    | '/p/testimonial/$token'
    | '/p/unsubscribe/$token'
    | '/p/upload/$token'
    | '/portal/approvals/$approval'
    | '/portal/apps/$tab'
    | '/portal/projects/$project'
    | '/agreements/'
    | '/approvals/'
    | '/assets/'
    | '/automations/'
    | '/bookings/'
    | '/budgets/'
    | '/calendar/'
    | '/calls/'
    | '/campaigns/'
    | '/chat/'
    | '/clients/'
    | '/contacts/'
    | '/cycles/'
    | '/dashboards/'
    | '/deals/'
    | '/docs/'
    | '/files/'
    | '/forms/'
    | '/freelancers/'
    | '/getting-started/'
    | '/help-centre/'
    | '/hiring/'
    | '/inbox/'
    | '/initiatives/'
    | '/invoices/'
    | '/leaderboard/'
    | '/meetings/'
    | '/my-work/'
    | '/notifications/'
    | '/o/'
    | '/onboarding/'
    | '/outreach/'
    | '/payments/'
    | '/policies/'
    | '/portfolios/'
    | '/presets/'
    | '/projects/'
    | '/proofs/'
    | '/proposals/'
    | '/queues/'
    | '/reports/'
    | '/reviews/'
    | '/sales/'
    | '/schedule/'
    | '/search/'
    | '/social/'
    | '/subscriptions/'
    | '/team/'
    | '/tickets/'
    | '/time-off/'
    | '/time/'
    | '/tours/'
    | '/triage/'
    | '/updates/'
    | '/vault/'
    | '/web-feedback/'
    | '/portal/approvals/'
    | '/portal/projects/'
    | '/automations/messages/$template'
    | '/bookings/pages/$page'
    | '/clients/$client/$tab'
    | '/clients/$client/lifecycle'
    | '/dashboards/template/$template'
    | '/files/$file/office'
    | '/forms/$form/analytics'
    | '/forms/$form/edit'
    | '/forms/$form/responses'
    | '/my-work/lists/$list'
    | '/o/$object/$id'
    | '/onboarding/templates/$template'
    | '/projects/$project/$tab'
    | '/projects/$project/scope'
    | '/proposals/$proposal/analytics'
    | '/proposals/$proposal/edit'
    | '/reports/clients/$client'
    | '/reports/present/$report'
    | '/reviews/$client/$quarter'
    | '/settings/$group/$page'
    | '/templates/$kind/$template'
    | '/work/templates/$template'
    | '/p/book/manage/$token'
    | '/p/referral/$ws/$code'
    | '/automations/$workflow/'
    | '/automations/messages/'
    | '/o/$object/'
    | '/reports/clients/'
    | '/work/templates/'
    | '/automations/$workflow/runs/$run'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/join'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/trust'
    | '/$'
    | '/apps'
    | '/audiences'
    | '/expenses'
    | '/feedback'
    | '/follows'
    | '/goals'
    | '/home'
    | '/portfolio'
    | '/purchases'
    | '/surveys'
    | '/website'
    | '/workspaces'
    | '/apply/$job'
    | '/help/$slug'
    | '/invite/$token'
    | '/n/$token'
    | '/portal/briefs'
    | '/portal/calendar'
    | '/portal/changes'
    | '/portal/files'
    | '/portal/forms'
    | '/portal/help'
    | '/portal/messages'
    | '/portal/money'
    | '/portal/plans'
    | '/portal/reports'
    | '/portal/requests'
    | '/portal/settings'
    | '/portal/sign-in'
    | '/portal/social'
    | '/portal/store'
    | '/portal/tickets'
    | '/portal/welcome'
    | '/r/$token'
    | '/setup/$step'
    | '/freelancer'
    | '/portal'
    | '/agreements/$agreement'
    | '/agreements/id-reviews'
    | '/automations/map'
    | '/automations/n8n'
    | '/automations/runs'
    | '/automations/templates'
    | '/budgets/$tab'
    | '/calendar/overlap'
    | '/calls/playlists'
    | '/campaigns/$campaign'
    | '/catalogue/$tab'
    | '/catalogue/store'
    | '/chat/$channel'
    | '/clients/duplicates'
    | '/contacts/$contact'
    | '/cycles/$cycle'
    | '/dashboards/$dashboard'
    | '/deals/$deal'
    | '/deals/follow-ups'
    | '/docs/$doc'
    | '/files/$folder'
    | '/files/storage'
    | '/files/trash'
    | '/finance/$tab'
    | '/freelancers/$freelancer'
    | '/freelancers/payouts'
    | '/freelancers/requisitions'
    | '/hiring/$job'
    | '/import/$type'
    | '/inbox/$thread'
    | '/inbox/whatsapp-templates'
    | '/initiatives/$initiative'
    | '/invoices/$invoice'
    | '/invoices/aging'
    | '/lab/$family'
    | '/meetings/$meeting'
    | '/onboarding/$run'
    | '/one-on-ones/$person'
    | '/outreach/$sequence'
    | '/outreach/deliverability'
    | '/outreach/lists'
    | '/outreach/mailboxes'
    | '/outreach/warmup'
    | '/portfolios/$portfolio'
    | '/proofs/$proof'
    | '/proposals/templates'
    | '/queues/$role'
    | '/reports/$report'
    | '/reports/attribution'
    | '/reports/revenue-analytics'
    | '/reports/targets'
    | '/sales/rep'
    | '/sales/rules'
    | '/spaces/$space'
    | '/subscriptions/$subscription'
    | '/subscriptions/recurring'
    | '/tasks/$key'
    | '/team/$member'
    | '/tickets/$ticket'
    | '/time/approvals'
    | '/time/ledger'
    | '/time/timer'
    | '/tours/stuck'
    | '/whiteboards/$id'
    | '/p/action/$token'
    | '/p/book/$slug'
    | '/p/form/$slug'
    | '/p/freelancer/$token'
    | '/p/help/$slug'
    | '/p/pay/$token'
    | '/p/proposal/$token'
    | '/p/share/$token'
    | '/p/sign/$token'
    | '/p/survey/$token'
    | '/p/testimonial/$token'
    | '/p/unsubscribe/$token'
    | '/p/upload/$token'
    | '/portal/approvals/$approval'
    | '/portal/apps/$tab'
    | '/portal/projects/$project'
    | '/agreements'
    | '/approvals'
    | '/assets'
    | '/automations'
    | '/bookings'
    | '/budgets'
    | '/calendar'
    | '/calls'
    | '/campaigns'
    | '/chat'
    | '/clients'
    | '/contacts'
    | '/cycles'
    | '/dashboards'
    | '/deals'
    | '/docs'
    | '/files'
    | '/forms'
    | '/freelancers'
    | '/getting-started'
    | '/help-centre'
    | '/hiring'
    | '/inbox'
    | '/initiatives'
    | '/invoices'
    | '/leaderboard'
    | '/meetings'
    | '/my-work'
    | '/notifications'
    | '/o'
    | '/onboarding'
    | '/outreach'
    | '/payments'
    | '/policies'
    | '/portfolios'
    | '/presets'
    | '/projects'
    | '/proofs'
    | '/proposals'
    | '/queues'
    | '/reports'
    | '/reviews'
    | '/sales'
    | '/schedule'
    | '/search'
    | '/social'
    | '/subscriptions'
    | '/team'
    | '/tickets'
    | '/time-off'
    | '/time'
    | '/tours'
    | '/triage'
    | '/updates'
    | '/vault'
    | '/web-feedback'
    | '/portal/approvals'
    | '/portal/projects'
    | '/automations/messages/$template'
    | '/bookings/pages/$page'
    | '/clients/$client/$tab'
    | '/clients/$client/lifecycle'
    | '/dashboards/template/$template'
    | '/files/$file/office'
    | '/forms/$form/analytics'
    | '/forms/$form/edit'
    | '/forms/$form/responses'
    | '/my-work/lists/$list'
    | '/o/$object/$id'
    | '/onboarding/templates/$template'
    | '/projects/$project/$tab'
    | '/projects/$project/scope'
    | '/proposals/$proposal/analytics'
    | '/proposals/$proposal/edit'
    | '/reports/clients/$client'
    | '/reports/present/$report'
    | '/reviews/$client/$quarter'
    | '/settings/$group/$page'
    | '/templates/$kind/$template'
    | '/work/templates/$template'
    | '/p/book/manage/$token'
    | '/p/referral/$ws/$code'
    | '/automations/$workflow'
    | '/automations/messages'
    | '/o/$object'
    | '/reports/clients'
    | '/work/templates'
    | '/automations/$workflow/runs/$run'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/join'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/trust'
    | '/_app/$'
    | '/_app/apps'
    | '/_app/audiences'
    | '/_app/expenses'
    | '/_app/feedback'
    | '/_app/follows'
    | '/_app/goals'
    | '/_app/home'
    | '/_app/portfolio'
    | '/_app/purchases'
    | '/_app/surveys'
    | '/_app/website'
    | '/_app/workspaces'
    | '/apply/$job'
    | '/help/$slug'
    | '/invite/$token'
    | '/n/$token'
    | '/portal/briefs'
    | '/portal/calendar'
    | '/portal/changes'
    | '/portal/files'
    | '/portal/forms'
    | '/portal/help'
    | '/portal/messages'
    | '/portal/money'
    | '/portal/plans'
    | '/portal/reports'
    | '/portal/requests'
    | '/portal/settings'
    | '/portal/sign-in'
    | '/portal/social'
    | '/portal/store'
    | '/portal/tickets'
    | '/portal/welcome'
    | '/r/$token'
    | '/setup/$step'
    | '/freelancer/'
    | '/portal/'
    | '/_app/agreements/$agreement'
    | '/_app/agreements/id-reviews'
    | '/_app/automations/map'
    | '/_app/automations/n8n'
    | '/_app/automations/runs'
    | '/_app/automations/templates'
    | '/_app/budgets/$tab'
    | '/_app/calendar/overlap'
    | '/_app/calls/playlists'
    | '/_app/campaigns/$campaign'
    | '/_app/catalogue/$tab'
    | '/_app/catalogue/store'
    | '/_app/chat/$channel'
    | '/_app/clients/duplicates'
    | '/_app/contacts/$contact'
    | '/_app/cycles/$cycle'
    | '/_app/dashboards/$dashboard'
    | '/_app/deals/$deal'
    | '/_app/deals/follow-ups'
    | '/_app/docs/$doc'
    | '/_app/files/$folder'
    | '/_app/files/storage'
    | '/_app/files/trash'
    | '/_app/finance/$tab'
    | '/_app/freelancers/$freelancer'
    | '/_app/freelancers/payouts'
    | '/_app/freelancers/requisitions'
    | '/_app/hiring/$job'
    | '/_app/import/$type'
    | '/_app/inbox/$thread'
    | '/_app/inbox/whatsapp-templates'
    | '/_app/initiatives/$initiative'
    | '/_app/invoices/$invoice'
    | '/_app/invoices/aging'
    | '/_app/lab/$family'
    | '/_app/meetings/$meeting'
    | '/_app/onboarding/$run'
    | '/_app/one-on-ones/$person'
    | '/_app/outreach/$sequence'
    | '/_app/outreach/deliverability'
    | '/_app/outreach/lists'
    | '/_app/outreach/mailboxes'
    | '/_app/outreach/warmup'
    | '/_app/portfolios/$portfolio'
    | '/_app/proofs/$proof'
    | '/_app/proposals/templates'
    | '/_app/queues/$role'
    | '/_app/reports/$report'
    | '/_app/reports/attribution'
    | '/_app/reports/revenue-analytics'
    | '/_app/reports/targets'
    | '/_app/sales/rep'
    | '/_app/sales/rules'
    | '/_app/spaces/$space'
    | '/_app/subscriptions/$subscription'
    | '/_app/subscriptions/recurring'
    | '/_app/tasks/$key'
    | '/_app/team/$member'
    | '/_app/tickets/$ticket'
    | '/_app/time/approvals'
    | '/_app/time/ledger'
    | '/_app/time/timer'
    | '/_app/tours/stuck'
    | '/_app/whiteboards/$id'
    | '/p/action/$token'
    | '/p/book/$slug'
    | '/p/form/$slug'
    | '/p/freelancer/$token'
    | '/p/help/$slug'
    | '/p/pay/$token'
    | '/p/proposal/$token'
    | '/p/share/$token'
    | '/p/sign/$token'
    | '/p/survey/$token'
    | '/p/testimonial/$token'
    | '/p/unsubscribe/$token'
    | '/p/upload/$token'
    | '/portal/approvals/$approval'
    | '/portal/apps/$tab'
    | '/portal/projects/$project'
    | '/_app/agreements/'
    | '/_app/approvals/'
    | '/_app/assets/'
    | '/_app/automations/'
    | '/_app/bookings/'
    | '/_app/budgets/'
    | '/_app/calendar/'
    | '/_app/calls/'
    | '/_app/campaigns/'
    | '/_app/chat/'
    | '/_app/clients/'
    | '/_app/contacts/'
    | '/_app/cycles/'
    | '/_app/dashboards/'
    | '/_app/deals/'
    | '/_app/docs/'
    | '/_app/files/'
    | '/_app/forms/'
    | '/_app/freelancers/'
    | '/_app/getting-started/'
    | '/_app/help-centre/'
    | '/_app/hiring/'
    | '/_app/inbox/'
    | '/_app/initiatives/'
    | '/_app/invoices/'
    | '/_app/leaderboard/'
    | '/_app/meetings/'
    | '/_app/my-work/'
    | '/_app/notifications/'
    | '/_app/o/'
    | '/_app/onboarding/'
    | '/_app/outreach/'
    | '/_app/payments/'
    | '/_app/policies/'
    | '/_app/portfolios/'
    | '/_app/presets/'
    | '/_app/projects/'
    | '/_app/proofs/'
    | '/_app/proposals/'
    | '/_app/queues/'
    | '/_app/reports/'
    | '/_app/reviews/'
    | '/_app/sales/'
    | '/_app/schedule/'
    | '/_app/search/'
    | '/_app/social/'
    | '/_app/subscriptions/'
    | '/_app/team/'
    | '/_app/tickets/'
    | '/_app/time-off/'
    | '/_app/time/'
    | '/_app/tours/'
    | '/_app/triage/'
    | '/_app/updates/'
    | '/_app/vault/'
    | '/_app/web-feedback/'
    | '/portal/approvals/'
    | '/portal/projects/'
    | '/_app/automations/messages/$template'
    | '/_app/bookings/pages/$page'
    | '/_app/clients/$client/$tab'
    | '/_app/clients/$client/lifecycle'
    | '/_app/dashboards/template/$template'
    | '/_app/files/$file/office'
    | '/_app/forms/$form/analytics'
    | '/_app/forms/$form/edit'
    | '/_app/forms/$form/responses'
    | '/_app/my-work/lists/$list'
    | '/_app/o/$object/$id'
    | '/_app/onboarding/templates/$template'
    | '/_app/projects/$project/$tab'
    | '/_app/projects/$project/scope'
    | '/_app/proposals/$proposal/analytics'
    | '/_app/proposals/$proposal/edit'
    | '/_app/reports/clients/$client'
    | '/_app/reports/present/$report'
    | '/_app/reviews/$client/$quarter'
    | '/_app/settings/$group/$page'
    | '/_app/templates/$kind/$template'
    | '/_app/work/templates/$template'
    | '/p/book/manage/$token'
    | '/p/referral/$ws/$code'
    | '/_app/automations/$workflow/'
    | '/_app/automations/messages/'
    | '/_app/o/$object/'
    | '/_app/reports/clients/'
    | '/_app/work/templates/'
    | '/_app/automations/$workflow/runs/$run'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  JoinRoute: typeof JoinRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  TrustRoute: typeof TrustRoute
  ApplyJobRoute: typeof ApplyJobRoute
  HelpSlugRoute: typeof HelpSlugRoute
  InviteTokenRoute: typeof InviteTokenRoute
  NTokenRoute: typeof NTokenRoute
  PortalBriefsRoute: typeof PortalBriefsRoute
  PortalCalendarRoute: typeof PortalCalendarRoute
  PortalChangesRoute: typeof PortalChangesRoute
  PortalFilesRoute: typeof PortalFilesRoute
  PortalFormsRoute: typeof PortalFormsRoute
  PortalHelpRoute: typeof PortalHelpRoute
  PortalMessagesRoute: typeof PortalMessagesRoute
  PortalMoneyRoute: typeof PortalMoneyRoute
  PortalPlansRoute: typeof PortalPlansRoute
  PortalReportsRoute: typeof PortalReportsRoute
  PortalRequestsRoute: typeof PortalRequestsRoute
  PortalSettingsRoute: typeof PortalSettingsRoute
  PortalSignInRoute: typeof PortalSignInRoute
  PortalSocialRoute: typeof PortalSocialRoute
  PortalStoreRoute: typeof PortalStoreRoute
  PortalTicketsRoute: typeof PortalTicketsRoute
  PortalWelcomeRoute: typeof PortalWelcomeRoute
  RTokenRoute: typeof RTokenRoute
  SetupStepRoute: typeof SetupStepRoute
  FreelancerIndexRoute: typeof FreelancerIndexRoute
  PortalIndexRoute: typeof PortalIndexRoute
  PActionTokenRoute: typeof PActionTokenRoute
  PBookSlugRoute: typeof PBookSlugRoute
  PFormSlugRoute: typeof PFormSlugRoute
  PFreelancerTokenRoute: typeof PFreelancerTokenRoute
  PHelpSlugRoute: typeof PHelpSlugRoute
  PPayTokenRoute: typeof PPayTokenRoute
  PProposalTokenRoute: typeof PProposalTokenRoute
  PShareTokenRoute: typeof PShareTokenRoute
  PSignTokenRoute: typeof PSignTokenRoute
  PSurveyTokenRoute: typeof PSurveyTokenRoute
  PTestimonialTokenRoute: typeof PTestimonialTokenRoute
  PUnsubscribeTokenRoute: typeof PUnsubscribeTokenRoute
  PUploadTokenRoute: typeof PUploadTokenRoute
  PortalApprovalsApprovalRoute: typeof PortalApprovalsApprovalRoute
  PortalAppsTabRoute: typeof PortalAppsTabRoute
  PortalProjectsProjectRoute: typeof PortalProjectsProjectRoute
  PortalApprovalsIndexRoute: typeof PortalApprovalsIndexRoute
  PortalProjectsIndexRoute: typeof PortalProjectsIndexRoute
  PBookManageTokenRoute: typeof PBookManageTokenRoute
  PReferralWsCodeRoute: typeof PReferralWsCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trust': {
      id: '/trust'
      path: '/trust'
      fullPath: '/trust'
      preLoaderRoute: typeof TrustRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/$': {
      id: '/_app/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AppSplatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/apps': {
      id: '/_app/apps'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AppAppsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audiences': {
      id: '/_app/audiences'
      path: '/audiences'
      fullPath: '/audiences'
      preLoaderRoute: typeof AppAudiencesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/expenses': {
      id: '/_app/expenses'
      path: '/expenses'
      fullPath: '/expenses'
      preLoaderRoute: typeof AppExpensesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/feedback': {
      id: '/_app/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof AppFeedbackRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/follows': {
      id: '/_app/follows'
      path: '/follows'
      fullPath: '/follows'
      preLoaderRoute: typeof AppFollowsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/goals': {
      id: '/_app/goals'
      path: '/goals'
      fullPath: '/goals'
      preLoaderRoute: typeof AppGoalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/portfolio': {
      id: '/_app/portfolio'
      path: '/portfolio'
      fullPath: '/portfolio'
      preLoaderRoute: typeof AppPortfolioRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchases': {
      id: '/_app/purchases'
      path: '/purchases'
      fullPath: '/purchases'
      preLoaderRoute: typeof AppPurchasesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/surveys': {
      id: '/_app/surveys'
      path: '/surveys'
      fullPath: '/surveys'
      preLoaderRoute: typeof AppSurveysRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/website': {
      id: '/_app/website'
      path: '/website'
      fullPath: '/website'
      preLoaderRoute: typeof AppWebsiteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workspaces': {
      id: '/_app/workspaces'
      path: '/workspaces'
      fullPath: '/workspaces'
      preLoaderRoute: typeof AppWorkspacesRouteImport
      parentRoute: typeof AppRoute
    }
    '/apply/$job': {
      id: '/apply/$job'
      path: '/apply/$job'
      fullPath: '/apply/$job'
      preLoaderRoute: typeof ApplyJobRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/freelancer/': {
      id: '/freelancer/'
      path: '/freelancer'
      fullPath: '/freelancer/'
      preLoaderRoute: typeof FreelancerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/$slug': {
      id: '/help/$slug'
      path: '/help/$slug'
      fullPath: '/help/$slug'
      preLoaderRoute: typeof HelpSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/n/$token': {
      id: '/n/$token'
      path: '/n/$token'
      fullPath: '/n/$token'
      preLoaderRoute: typeof NTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/': {
      id: '/portal/'
      path: '/portal'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/briefs': {
      id: '/portal/briefs'
      path: '/portal/briefs'
      fullPath: '/portal/briefs'
      preLoaderRoute: typeof PortalBriefsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/calendar': {
      id: '/portal/calendar'
      path: '/portal/calendar'
      fullPath: '/portal/calendar'
      preLoaderRoute: typeof PortalCalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/changes': {
      id: '/portal/changes'
      path: '/portal/changes'
      fullPath: '/portal/changes'
      preLoaderRoute: typeof PortalChangesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/files': {
      id: '/portal/files'
      path: '/portal/files'
      fullPath: '/portal/files'
      preLoaderRoute: typeof PortalFilesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/forms': {
      id: '/portal/forms'
      path: '/portal/forms'
      fullPath: '/portal/forms'
      preLoaderRoute: typeof PortalFormsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/help': {
      id: '/portal/help'
      path: '/portal/help'
      fullPath: '/portal/help'
      preLoaderRoute: typeof PortalHelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/messages': {
      id: '/portal/messages'
      path: '/portal/messages'
      fullPath: '/portal/messages'
      preLoaderRoute: typeof PortalMessagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/money': {
      id: '/portal/money'
      path: '/portal/money'
      fullPath: '/portal/money'
      preLoaderRoute: typeof PortalMoneyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/plans': {
      id: '/portal/plans'
      path: '/portal/plans'
      fullPath: '/portal/plans'
      preLoaderRoute: typeof PortalPlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/reports': {
      id: '/portal/reports'
      path: '/portal/reports'
      fullPath: '/portal/reports'
      preLoaderRoute: typeof PortalReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/requests': {
      id: '/portal/requests'
      path: '/portal/requests'
      fullPath: '/portal/requests'
      preLoaderRoute: typeof PortalRequestsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/settings': {
      id: '/portal/settings'
      path: '/portal/settings'
      fullPath: '/portal/settings'
      preLoaderRoute: typeof PortalSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/sign-in': {
      id: '/portal/sign-in'
      path: '/portal/sign-in'
      fullPath: '/portal/sign-in'
      preLoaderRoute: typeof PortalSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/social': {
      id: '/portal/social'
      path: '/portal/social'
      fullPath: '/portal/social'
      preLoaderRoute: typeof PortalSocialRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/store': {
      id: '/portal/store'
      path: '/portal/store'
      fullPath: '/portal/store'
      preLoaderRoute: typeof PortalStoreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/tickets': {
      id: '/portal/tickets'
      path: '/portal/tickets'
      fullPath: '/portal/tickets'
      preLoaderRoute: typeof PortalTicketsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/welcome': {
      id: '/portal/welcome'
      path: '/portal/welcome'
      fullPath: '/portal/welcome'
      preLoaderRoute: typeof PortalWelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$token': {
      id: '/r/$token'
      path: '/r/$token'
      fullPath: '/r/$token'
      preLoaderRoute: typeof RTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup/$step': {
      id: '/setup/$step'
      path: '/setup/$step'
      fullPath: '/setup/$step'
      preLoaderRoute: typeof SetupStepRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/agreements/': {
      id: '/_app/agreements/'
      path: '/agreements'
      fullPath: '/agreements/'
      preLoaderRoute: typeof AppAgreementsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agreements/$agreement': {
      id: '/_app/agreements/$agreement'
      path: '/agreements/$agreement'
      fullPath: '/agreements/$agreement'
      preLoaderRoute: typeof AppAgreementsAgreementRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agreements/id-reviews': {
      id: '/_app/agreements/id-reviews'
      path: '/agreements/id-reviews'
      fullPath: '/agreements/id-reviews'
      preLoaderRoute: typeof AppAgreementsIdReviewsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/approvals/': {
      id: '/_app/approvals/'
      path: '/approvals'
      fullPath: '/approvals/'
      preLoaderRoute: typeof AppApprovalsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/assets/': {
      id: '/_app/assets/'
      path: '/assets'
      fullPath: '/assets/'
      preLoaderRoute: typeof AppAssetsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/automations/': {
      id: '/_app/automations/'
      path: '/automations'
      fullPath: '/automations/'
      preLoaderRoute: typeof AppAutomationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/automations/map': {
      id: '/_app/automations/map'
      path: '/automations/map'
      fullPath: '/automations/map'
      preLoaderRoute: typeof AppAutomationsMapRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/automations/n8n': {
      id: '/_app/automations/n8n'
      path: '/automations/n8n'
      fullPath: '/automations/n8n'
      preLoaderRoute: typeof AppAutomationsN8nRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/automations/runs': {
      id: '/_app/automations/runs'
      path: '/automations/runs'
      fullPath: '/automations/runs'
      preLoaderRoute: typeof AppAutomationsRunsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/automations/templates': {
      id: '/_app/automations/templates'
      path: '/automations/templates'
      fullPath: '/automations/templates'
      preLoaderRoute: typeof AppAutomationsTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bookings/': {
      id: '/_app/bookings/'
      path: '/bookings'
      fullPath: '/bookings/'
      preLoaderRoute: typeof AppBookingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/budgets/': {
      id: '/_app/budgets/'
      path: '/budgets'
      fullPath: '/budgets/'
      preLoaderRoute: typeof AppBudgetsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/budgets/$tab': {
      id: '/_app/budgets/$tab'
      path: '/budgets/$tab'
      fullPath: '/budgets/$tab'
      preLoaderRoute: typeof AppBudgetsTabRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendar/': {
      id: '/_app/calendar/'
      path: '/calendar'
      fullPath: '/calendar/'
      preLoaderRoute: typeof AppCalendarIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendar/overlap': {
      id: '/_app/calendar/overlap'
      path: '/calendar/overlap'
      fullPath: '/calendar/overlap'
      preLoaderRoute: typeof AppCalendarOverlapRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calls/': {
      id: '/_app/calls/'
      path: '/calls'
      fullPath: '/calls/'
      preLoaderRoute: typeof AppCallsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calls/playlists': {
      id: '/_app/calls/playlists'
      path: '/calls/playlists'
      fullPath: '/calls/playlists'
      preLoaderRoute: typeof AppCallsPlaylistsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/campaigns/': {
      id: '/_app/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof AppCampaignsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/campaigns/$campaign': {
      id: '/_app/campaigns/$campaign'
      path: '/campaigns/$campaign'
      fullPath: '/campaigns/$campaign'
      preLoaderRoute: typeof AppCampaignsCampaignRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalogue/$tab': {
      id: '/_app/catalogue/$tab'
      path: '/catalogue/$tab'
      fullPath: '/catalogue/$tab'
      preLoaderRoute: typeof AppCatalogueTabRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalogue/store': {
      id: '/_app/catalogue/store'
      path: '/catalogue/store'
      fullPath: '/catalogue/store'
      preLoaderRoute: typeof AppCatalogueStoreRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chat/': {
      id: '/_app/chat/'
      path: '/chat'
      fullPath: '/chat/'
      preLoaderRoute: typeof AppChatIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chat/$channel': {
      id: '/_app/chat/$channel'
      path: '/chat/$channel'
      fullPath: '/chat/$channel'
      preLoaderRoute: typeof AppChatChannelRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/': {
      id: '/_app/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AppClientsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/duplicates': {
      id: '/_app/clients/duplicates'
      path: '/clients/duplicates'
      fullPath: '/clients/duplicates'
      preLoaderRoute: typeof AppClientsDuplicatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contacts/': {
      id: '/_app/contacts/'
      path: '/contacts'
      fullPath: '/contacts/'
      preLoaderRoute: typeof AppContactsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contacts/$contact': {
      id: '/_app/contacts/$contact'
      path: '/contacts/$contact'
      fullPath: '/contacts/$contact'
      preLoaderRoute: typeof AppContactsContactRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cycles/': {
      id: '/_app/cycles/'
      path: '/cycles'
      fullPath: '/cycles/'
      preLoaderRoute: typeof AppCyclesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cycles/$cycle': {
      id: '/_app/cycles/$cycle'
      path: '/cycles/$cycle'
      fullPath: '/cycles/$cycle'
      preLoaderRoute: typeof AppCyclesCycleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboards/': {
      id: '/_app/dashboards/'
      path: '/dashboards'
      fullPath: '/dashboards/'
      preLoaderRoute: typeof AppDashboardsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboards/$dashboard': {
      id: '/_app/dashboards/$dashboard'
      path: '/dashboards/$dashboard'
      fullPath: '/dashboards/$dashboard'
      preLoaderRoute: typeof AppDashboardsDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/deals/': {
      id: '/_app/deals/'
      path: '/deals'
      fullPath: '/deals/'
      preLoaderRoute: typeof AppDealsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/deals/$deal': {
      id: '/_app/deals/$deal'
      path: '/deals/$deal'
      fullPath: '/deals/$deal'
      preLoaderRoute: typeof AppDealsDealRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/deals/follow-ups': {
      id: '/_app/deals/follow-ups'
      path: '/deals/follow-ups'
      fullPath: '/deals/follow-ups'
      preLoaderRoute: typeof AppDealsFollowUpsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs/': {
      id: '/_app/docs/'
      path: '/docs'
      fullPath: '/docs/'
      preLoaderRoute: typeof AppDocsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs/$doc': {
      id: '/_app/docs/$doc'
      path: '/docs/$doc'
      fullPath: '/docs/$doc'
      preLoaderRoute: typeof AppDocsDocRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/files/': {
      id: '/_app/files/'
      path: '/files'
      fullPath: '/files/'
      preLoaderRoute: typeof AppFilesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/files/$folder': {
      id: '/_app/files/$folder'
      path: '/files/$folder'
      fullPath: '/files/$folder'
      preLoaderRoute: typeof AppFilesFolderRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/files/storage': {
      id: '/_app/files/storage'
      path: '/files/storage'
      fullPath: '/files/storage'
      preLoaderRoute: typeof AppFilesStorageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/files/trash': {
      id: '/_app/files/trash'
      path: '/files/trash'
      fullPath: '/files/trash'
      preLoaderRoute: typeof AppFilesTrashRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finance/$tab': {
      id: '/_app/finance/$tab'
      path: '/finance/$tab'
      fullPath: '/finance/$tab'
      preLoaderRoute: typeof AppFinanceTabRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forms/': {
      id: '/_app/forms/'
      path: '/forms'
      fullPath: '/forms/'
      preLoaderRoute: typeof AppFormsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/freelancers/': {
      id: '/_app/freelancers/'
      path: '/freelancers'
      fullPath: '/freelancers/'
      preLoaderRoute: typeof AppFreelancersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/freelancers/$freelancer': {
      id: '/_app/freelancers/$freelancer'
      path: '/freelancers/$freelancer'
      fullPath: '/freelancers/$freelancer'
      preLoaderRoute: typeof AppFreelancersFreelancerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/freelancers/payouts': {
      id: '/_app/freelancers/payouts'
      path: '/freelancers/payouts'
      fullPath: '/freelancers/payouts'
      preLoaderRoute: typeof AppFreelancersPayoutsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/freelancers/requisitions': {
      id: '/_app/freelancers/requisitions'
      path: '/freelancers/requisitions'
      fullPath: '/freelancers/requisitions'
      preLoaderRoute: typeof AppFreelancersRequisitionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/getting-started/': {
      id: '/_app/getting-started/'
      path: '/getting-started'
      fullPath: '/getting-started/'
      preLoaderRoute: typeof AppGettingStartedIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help-centre/': {
      id: '/_app/help-centre/'
      path: '/help-centre'
      fullPath: '/help-centre/'
      preLoaderRoute: typeof AppHelpCentreIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hiring/': {
      id: '/_app/hiring/'
      path: '/hiring'
      fullPath: '/hiring/'
      preLoaderRoute: typeof AppHiringIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hiring/$job': {
      id: '/_app/hiring/$job'
      path: '/hiring/$job'
      fullPath: '/hiring/$job'
      preLoaderRoute: typeof AppHiringJobRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/import/$type': {
      id: '/_app/import/$type'
      path: '/import/$type'
      fullPath: '/import/$type'
      preLoaderRoute: typeof AppImportTypeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox/': {
      id: '/_app/inbox/'
      path: '/inbox'
      fullPath: '/inbox/'
      preLoaderRoute: typeof AppInboxIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox/$thread': {
      id: '/_app/inbox/$thread'
      path: '/inbox/$thread'
      fullPath: '/inbox/$thread'
      preLoaderRoute: typeof AppInboxThreadRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox/whatsapp-templates': {
      id: '/_app/inbox/whatsapp-templates'
      path: '/inbox/whatsapp-templates'
      fullPath: '/inbox/whatsapp-templates'
      preLoaderRoute: typeof AppInboxWhatsappTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/initiatives/': {
      id: '/_app/initiatives/'
      path: '/initiatives'
      fullPath: '/initiatives/'
      preLoaderRoute: typeof AppInitiativesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/initiatives/$initiative': {
      id: '/_app/initiatives/$initiative'
      path: '/initiatives/$initiative'
      fullPath: '/initiatives/$initiative'
      preLoaderRoute: typeof AppInitiativesInitiativeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices/': {
      id: '/_app/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AppInvoicesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices/$invoice': {
      id: '/_app/invoices/$invoice'
      path: '/invoices/$invoice'
      fullPath: '/invoices/$invoice'
      preLoaderRoute: typeof AppInvoicesInvoiceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices/aging': {
      id: '/_app/invoices/aging'
      path: '/invoices/aging'
      fullPath: '/invoices/aging'
      preLoaderRoute: typeof AppInvoicesAgingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lab/$family': {
      id: '/_app/lab/$family'
      path: '/lab/$family'
      fullPath: '/lab/$family'
      preLoaderRoute: typeof AppLabFamilyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leaderboard/': {
      id: '/_app/leaderboard/'
      path: '/leaderboard'
      fullPath: '/leaderboard/'
      preLoaderRoute: typeof AppLeaderboardIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/': {
      id: '/_app/meetings/'
      path: '/meetings'
      fullPath: '/meetings/'
      preLoaderRoute: typeof AppMeetingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/$meeting': {
      id: '/_app/meetings/$meeting'
      path: '/meetings/$meeting'
      fullPath: '/meetings/$meeting'
      preLoaderRoute: typeof AppMeetingsMeetingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-work/': {
      id: '/_app/my-work/'
      path: '/my-work'
      fullPath: '/my-work/'
      preLoaderRoute: typeof AppMyWorkIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications/': {
      id: '/_app/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof AppNotificationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/o/': {
      id: '/_app/o/'
      path: '/o'
      fullPath: '/o/'
      preLoaderRoute: typeof AppOIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding/': {
      id: '/_app/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof AppOnboardingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding/$run': {
      id: '/_app/onboarding/$run'
      path: '/onboarding/$run'
      fullPath: '/onboarding/$run'
      preLoaderRoute: typeof AppOnboardingRunRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/one-on-ones/$person': {
      id: '/_app/one-on-ones/$person'
      path: '/one-on-ones/$person'
      fullPath: '/one-on-ones/$person'
      preLoaderRoute: typeof AppOneOnOnesPersonRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/outreach/': {
      id: '/_app/outreach/'
      path: '/outreach'
      fullPath: '/outreach/'
      preLoaderRoute: typeof AppOutreachIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/outreach/$sequence': {
      id: '/_app/outreach/$sequence'
      path: '/outreach/$sequence'
      fullPath: '/outreach/$sequence'
      preLoaderRoute: typeof AppOutreachSequenceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/outreach/deliverability': {
      id: '/_app/outreach/deliverability'
      path: '/outreach/deliverability'
      fullPath: '/outreach/deliverability'
      preLoaderRoute: typeof AppOutreachDeliverabilityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/outreach/lists': {
      id: '/_app/outreach/lists'
      path: '/outreach/lists'
      fullPath: '/outreach/lists'
      preLoaderRoute: typeof AppOutreachListsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/outreach/mailboxes': {
      id: '/_app/outreach/mailboxes'
      path: '/outreach/mailboxes'
      fullPath: '/outreach/mailboxes'
      preLoaderRoute: typeof AppOutreachMailboxesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/outreach/warmup': {
      id: '/_app/outreach/warmup'
      path: '/outreach/warmup'
      fullPath: '/outreach/warmup'
      preLoaderRoute: typeof AppOutreachWarmupRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payments/': {
      id: '/_app/payments/'
      path: '/payments'
      fullPath: '/payments/'
      preLoaderRoute: typeof AppPaymentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/policies/': {
      id: '/_app/policies/'
      path: '/policies'
      fullPath: '/policies/'
      preLoaderRoute: typeof AppPoliciesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/portfolios/': {
      id: '/_app/portfolios/'
      path: '/portfolios'
      fullPath: '/portfolios/'
      preLoaderRoute: typeof AppPortfoliosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/portfolios/$portfolio': {
      id: '/_app/portfolios/$portfolio'
      path: '/portfolios/$portfolio'
      fullPath: '/portfolios/$portfolio'
      preLoaderRoute: typeof AppPortfoliosPortfolioRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/presets/': {
      id: '/_app/presets/'
      path: '/presets'
      fullPath: '/presets/'
      preLoaderRoute: typeof AppPresetsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/proofs/': {
      id: '/_app/proofs/'
      path: '/proofs'
      fullPath: '/proofs/'
      preLoaderRoute: typeof AppProofsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/proofs/$proof': {
      id: '/_app/proofs/$proof'
      path: '/proofs/$proof'
      fullPath: '/proofs/$proof'
      preLoaderRoute: typeof AppProofsProofRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/proposals/': {
      id: '/_app/proposals/'
      path: '/proposals'
      fullPath: '/proposals/'
      preLoaderRoute: typeof AppProposalsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/proposals/templates': {
      id: '/_app/proposals/templates'
      path: '/proposals/templates'
      fullPath: '/proposals/templates'
      preLoaderRoute: typeof AppProposalsTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/queues/': {
      id: '/_app/queues/'
      path: '/queues'
      fullPath: '/queues/'
      preLoaderRoute: typeof AppQueuesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/queues/$role': {
      id: '/_app/queues/$role'
      path: '/queues/$role'
      fullPath: '/queues/$role'
      preLoaderRoute: typeof AppQueuesRoleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/': {
      id: '/_app/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AppReportsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/$report': {
      id: '/_app/reports/$report'
      path: '/reports/$report'
      fullPath: '/reports/$report'
      preLoaderRoute: typeof AppReportsReportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/attribution': {
      id: '/_app/reports/attribution'
      path: '/reports/attribution'
      fullPath: '/reports/attribution'
      preLoaderRoute: typeof AppReportsAttributionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/revenue-analytics': {
      id: '/_app/reports/revenue-analytics'
      path: '/reports/revenue-analytics'
      fullPath: '/reports/revenue-analytics'
      preLoaderRoute: typeof AppReportsRevenueAnalyticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/targets': {
      id: '/_app/reports/targets'
      path: '/reports/targets'
      fullPath: '/reports/targets'
      preLoaderRoute: typeof AppReportsTargetsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reviews/': {
      id: '/_app/reviews/'
      path: '/reviews'
      fullPath: '/reviews/'
      preLoaderRoute: typeof AppReviewsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/': {
      id: '/_app/sales/'
      path: '/sales'
      fullPath: '/sales/'
      preLoaderRoute: typeof AppSalesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/rep': {
      id: '/_app/sales/rep'
      path: '/sales/rep'
      fullPath: '/sales/rep'
      preLoaderRoute: typeof AppSalesRepRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/rules': {
      id: '/_app/sales/rules'
      path: '/sales/rules'
      fullPath: '/sales/rules'
      preLoaderRoute: typeof AppSalesRulesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/schedule/': {
      id: '/_app/schedule/'
      path: '/schedule'
      fullPath: '/schedule/'
      preLoaderRoute: typeof AppScheduleIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/search/': {
      id: '/_app/search/'
      path: '/search'
      fullPath: '/search/'
      preLoaderRoute: typeof AppSearchIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/social/': {
      id: '/_app/social/'
      path: '/social'
      fullPath: '/social/'
      preLoaderRoute: typeof AppSocialIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/spaces/$space': {
      id: '/_app/spaces/$space'
      path: '/spaces/$space'
      fullPath: '/spaces/$space'
      preLoaderRoute: typeof AppSpacesSpaceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/subscriptions/': {
      id: '/_app/subscriptions/'
      path: '/subscriptions'
      fullPath: '/subscriptions/'
      preLoaderRoute: typeof AppSubscriptionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/subscriptions/$subscription': {
      id: '/_app/subscriptions/$subscription'
      path: '/subscriptions/$subscription'
      fullPath: '/subscriptions/$subscription'
      preLoaderRoute: typeof AppSubscriptionsSubscriptionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/subscriptions/recurring': {
      id: '/_app/subscriptions/recurring'
      path: '/subscriptions/recurring'
      fullPath: '/subscriptions/recurring'
      preLoaderRoute: typeof AppSubscriptionsRecurringRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks/$key': {
      id: '/_app/tasks/$key'
      path: '/tasks/$key'
      fullPath: '/tasks/$key'
      preLoaderRoute: typeof AppTasksKeyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team/': {
      id: '/_app/team/'
      path: '/team'
      fullPath: '/team/'
      preLoaderRoute: typeof AppTeamIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team/$member': {
      id: '/_app/team/$member'
      path: '/team/$member'
      fullPath: '/team/$member'
      preLoaderRoute: typeof AppTeamMemberRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tickets/': {
      id: '/_app/tickets/'
      path: '/tickets'
      fullPath: '/tickets/'
      preLoaderRoute: typeof AppTicketsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tickets/$ticket': {
      id: '/_app/tickets/$ticket'
      path: '/tickets/$ticket'
      fullPath: '/tickets/$ticket'
      preLoaderRoute: typeof AppTicketsTicketRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/time-off/': {
      id: '/_app/time-off/'
      path: '/time-off'
      fullPath: '/time-off/'
      preLoaderRoute: typeof AppTimeOffIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/time/': {
      id: '/_app/time/'
      path: '/time'
      fullPath: '/time/'
      preLoaderRoute: typeof AppTimeIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/time/approvals': {
      id: '/_app/time/approvals'
      path: '/time/approvals'
      fullPath: '/time/approvals'
      preLoaderRoute: typeof AppTimeApprovalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/time/ledger': {
      id: '/_app/time/ledger'
      path: '/time/ledger'
      fullPath: '/time/ledger'
      preLoaderRoute: typeof AppTimeLedgerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/time/timer': {
      id: '/_app/time/timer'
      path: '/time/timer'
      fullPath: '/time/timer'
      preLoaderRoute: typeof AppTimeTimerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tours/': {
      id: '/_app/tours/'
      path: '/tours'
      fullPath: '/tours/'
      preLoaderRoute: typeof AppToursIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tours/stuck': {
      id: '/_app/tours/stuck'
      path: '/tours/stuck'
      fullPath: '/tours/stuck'
      preLoaderRoute: typeof AppToursStuckRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/triage/': {
      id: '/_app/triage/'
      path: '/triage'
      fullPath: '/triage/'
      preLoaderRoute: typeof AppTriageIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/updates/': {
      id: '/_app/updates/'
      path: '/updates'
      fullPath: '/updates/'
      preLoaderRoute: typeof AppUpdatesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vault/': {
      id: '/_app/vault/'
      path: '/vault'
      fullPath: '/vault/'
      preLoaderRoute: typeof AppVaultIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/web-feedback/': {
      id: '/_app/web-feedback/'
      path: '/web-feedback'
      fullPath: '/web-feedback/'
      preLoaderRoute: typeof AppWebFeedbackIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/whiteboards/$id': {
      id: '/_app/whiteboards/$id'
      path: '/whiteboards/$id'
      fullPath: '/whiteboards/$id'
      preLoaderRoute: typeof AppWhiteboardsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/p/action/$token': {
      id: '/p/action/$token'
      path: '/p/action/$token'
      fullPath: '/p/action/$token'
      preLoaderRoute: typeof PActionTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/book/$slug': {
      id: '/p/book/$slug'
      path: '/p/book/$slug'
      fullPath: '/p/book/$slug'
      preLoaderRoute: typeof PBookSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/form/$slug': {
      id: '/p/form/$slug'
      path: '/p/form/$slug'
      fullPath: '/p/form/$slug'
      preLoaderRoute: typeof PFormSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/freelancer/$token': {
      id: '/p/freelancer/$token'
      path: '/p/freelancer/$token'
      fullPath: '/p/freelancer/$token'
      preLoaderRoute: typeof PFreelancerTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/help/$slug': {
      id: '/p/help/$slug'
      path: '/p/help/$slug'
      fullPath: '/p/help/$slug'
      preLoaderRoute: typeof PHelpSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/pay/$token': {
      id: '/p/pay/$token'
      path: '/p/pay/$token'
      fullPath: '/p/pay/$token'
      preLoaderRoute: typeof PPayTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/proposal/$token': {
      id: '/p/proposal/$token'
      path: '/p/proposal/$token'
      fullPath: '/p/proposal/$token'
      preLoaderRoute: typeof PProposalTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/share/$token': {
      id: '/p/share/$token'
      path: '/p/share/$token'
      fullPath: '/p/share/$token'
      preLoaderRoute: typeof PShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/sign/$token': {
      id: '/p/sign/$token'
      path: '/p/sign/$token'
      fullPath: '/p/sign/$token'
      preLoaderRoute: typeof PSignTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/survey/$token': {
      id: '/p/survey/$token'
      path: '/p/survey/$token'
      fullPath: '/p/survey/$token'
      preLoaderRoute: typeof PSurveyTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/testimonial/$token': {
      id: '/p/testimonial/$token'
      path: '/p/testimonial/$token'
      fullPath: '/p/testimonial/$token'
      preLoaderRoute: typeof PTestimonialTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/unsubscribe/$token': {
      id: '/p/unsubscribe/$token'
      path: '/p/unsubscribe/$token'
      fullPath: '/p/unsubscribe/$token'
      preLoaderRoute: typeof PUnsubscribeTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/upload/$token': {
      id: '/p/upload/$token'
      path: '/p/upload/$token'
      fullPath: '/p/upload/$token'
      preLoaderRoute: typeof PUploadTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/approvals/': {
      id: '/portal/approvals/'
      path: '/portal/approvals'
      fullPath: '/portal/approvals/'
      preLoaderRoute: typeof PortalApprovalsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/approvals/$approval': {
      id: '/portal/approvals/$approval'
      path: '/portal/approvals/$approval'
      fullPath: '/portal/approvals/$approval'
      preLoaderRoute: typeof PortalApprovalsApprovalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/apps/$tab': {
      id: '/portal/apps/$tab'
      path: '/portal/apps/$tab'
      fullPath: '/portal/apps/$tab'
      preLoaderRoute: typeof PortalAppsTabRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/projects/': {
      id: '/portal/projects/'
      path: '/portal/projects'
      fullPath: '/portal/projects/'
      preLoaderRoute: typeof PortalProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/projects/$project': {
      id: '/portal/projects/$project'
      path: '/portal/projects/$project'
      fullPath: '/portal/projects/$project'
      preLoaderRoute: typeof PortalProjectsProjectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/automations/$workflow/': {
      id: '/_app/automations/$workflow/'
      path: '/automations/$workflow'
      fullPath: '/automations/$workflow/'
      preLoaderRoute: typeof AppAutomationsWorkflowIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/automations/messages/': {
      id: '/_app/automations/messages/'
      path: '/automations/messages'
      fullPath: '/automations/messages/'
      preLoaderRoute: typeof AppAutomationsMessagesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/automations/messages/$template': {
      id: '/_app/automations/messages/$template'
      path: '/automations/messages/$template'
      fullPath: '/automations/messages/$template'
      preLoaderRoute: typeof AppAutomationsMessagesTemplateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bookings/pages/$page': {
      id: '/_app/bookings/pages/$page'
      path: '/bookings/pages/$page'
      fullPath: '/bookings/pages/$page'
      preLoaderRoute: typeof AppBookingsPagesPageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/$client/$tab': {
      id: '/_app/clients/$client/$tab'
      path: '/clients/$client/$tab'
      fullPath: '/clients/$client/$tab'
      preLoaderRoute: typeof AppClientsClientTabRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/$client/lifecycle': {
      id: '/_app/clients/$client/lifecycle'
      path: '/clients/$client/lifecycle'
      fullPath: '/clients/$client/lifecycle'
      preLoaderRoute: typeof AppClientsClientLifecycleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboards/template/$template': {
      id: '/_app/dashboards/template/$template'
      path: '/dashboards/template/$template'
      fullPath: '/dashboards/template/$template'
      preLoaderRoute: typeof AppDashboardsTemplateTemplateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/files/$file/office': {
      id: '/_app/files/$file/office'
      path: '/files/$file/office'
      fullPath: '/files/$file/office'
      preLoaderRoute: typeof AppFilesFileOfficeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forms/$form/analytics': {
      id: '/_app/forms/$form/analytics'
      path: '/forms/$form/analytics'
      fullPath: '/forms/$form/analytics'
      preLoaderRoute: typeof AppFormsFormAnalyticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forms/$form/edit': {
      id: '/_app/forms/$form/edit'
      path: '/forms/$form/edit'
      fullPath: '/forms/$form/edit'
      preLoaderRoute: typeof AppFormsFormEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forms/$form/responses': {
      id: '/_app/forms/$form/responses'
      path: '/forms/$form/responses'
      fullPath: '/forms/$form/responses'
      preLoaderRoute: typeof AppFormsFormResponsesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-work/lists/$list': {
      id: '/_app/my-work/lists/$list'
      path: '/my-work/lists/$list'
      fullPath: '/my-work/lists/$list'
      preLoaderRoute: typeof AppMyWorkListsListRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/o/$object/': {
      id: '/_app/o/$object/'
      path: '/o/$object'
      fullPath: '/o/$object/'
      preLoaderRoute: typeof AppOObjectIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/o/$object/$id': {
      id: '/_app/o/$object/$id'
      path: '/o/$object/$id'
      fullPath: '/o/$object/$id'
      preLoaderRoute: typeof AppOObjectIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding/templates/$template': {
      id: '/_app/onboarding/templates/$template'
      path: '/onboarding/templates/$template'
      fullPath: '/onboarding/templates/$template'
      preLoaderRoute: typeof AppOnboardingTemplatesTemplateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$project/$tab': {
      id: '/_app/projects/$project/$tab'
      path: '/projects/$project/$tab'
      fullPath: '/projects/$project/$tab'
      preLoaderRoute: typeof AppProjectsProjectTabRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$project/scope': {
      id: '/_app/projects/$project/scope'
      path: '/projects/$project/scope'
      fullPath: '/projects/$project/scope'
      preLoaderRoute: typeof AppProjectsProjectScopeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/proposals/$proposal/analytics': {
      id: '/_app/proposals/$proposal/analytics'
      path: '/proposals/$proposal/analytics'
      fullPath: '/proposals/$proposal/analytics'
      preLoaderRoute: typeof AppProposalsProposalAnalyticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/proposals/$proposal/edit': {
      id: '/_app/proposals/$proposal/edit'
      path: '/proposals/$proposal/edit'
      fullPath: '/proposals/$proposal/edit'
      preLoaderRoute: typeof AppProposalsProposalEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/clients/': {
      id: '/_app/reports/clients/'
      path: '/reports/clients'
      fullPath: '/reports/clients/'
      preLoaderRoute: typeof AppReportsClientsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/clients/$client': {
      id: '/_app/reports/clients/$client'
      path: '/reports/clients/$client'
      fullPath: '/reports/clients/$client'
      preLoaderRoute: typeof AppReportsClientsClientRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/present/$report': {
      id: '/_app/reports/present/$report'
      path: '/reports/present/$report'
      fullPath: '/reports/present/$report'
      preLoaderRoute: typeof AppReportsPresentReportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reviews/$client/$quarter': {
      id: '/_app/reviews/$client/$quarter'
      path: '/reviews/$client/$quarter'
      fullPath: '/reviews/$client/$quarter'
      preLoaderRoute: typeof AppReviewsClientQuarterRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/$group/$page': {
      id: '/_app/settings/$group/$page'
      path: '/settings/$group/$page'
      fullPath: '/settings/$group/$page'
      preLoaderRoute: typeof AppSettingsGroupPageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/templates/$kind/$template': {
      id: '/_app/templates/$kind/$template'
      path: '/templates/$kind/$template'
      fullPath: '/templates/$kind/$template'
      preLoaderRoute: typeof AppTemplatesKindTemplateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/work/templates/': {
      id: '/_app/work/templates/'
      path: '/work/templates'
      fullPath: '/work/templates/'
      preLoaderRoute: typeof AppWorkTemplatesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/work/templates/$template': {
      id: '/_app/work/templates/$template'
      path: '/work/templates/$template'
      fullPath: '/work/templates/$template'
      preLoaderRoute: typeof AppWorkTemplatesTemplateRouteImport
      parentRoute: typeof AppRoute
    }
    '/p/book/manage/$token': {
      id: '/p/book/manage/$token'
      path: '/p/book/manage/$token'
      fullPath: '/p/book/manage/$token'
      preLoaderRoute: typeof PBookManageTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/referral/$ws/$code': {
      id: '/p/referral/$ws/$code'
      path: '/p/referral/$ws/$code'
      fullPath: '/p/referral/$ws/$code'
      preLoaderRoute: typeof PReferralWsCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/automations/$workflow/runs/$run': {
      id: '/_app/automations/$workflow/runs/$run'
      path: '/automations/$workflow/runs/$run'
      fullPath: '/automations/$workflow/runs/$run'
      preLoaderRoute: typeof AppAutomationsWorkflowRunsRunRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppSplatRoute: typeof AppSplatRoute
  AppAppsRoute: typeof AppAppsRoute
  AppAudiencesRoute: typeof AppAudiencesRoute
  AppExpensesRoute: typeof AppExpensesRoute
  AppFeedbackRoute: typeof AppFeedbackRoute
  AppFollowsRoute: typeof AppFollowsRoute
  AppGoalsRoute: typeof AppGoalsRoute
  AppHomeRoute: typeof AppHomeRoute
  AppPortfolioRoute: typeof AppPortfolioRoute
  AppPurchasesRoute: typeof AppPurchasesRoute
  AppSurveysRoute: typeof AppSurveysRoute
  AppWebsiteRoute: typeof AppWebsiteRoute
  AppWorkspacesRoute: typeof AppWorkspacesRoute
  AppAgreementsAgreementRoute: typeof AppAgreementsAgreementRoute
  AppAgreementsIdReviewsRoute: typeof AppAgreementsIdReviewsRoute
  AppAutomationsMapRoute: typeof AppAutomationsMapRoute
  AppAutomationsN8nRoute: typeof AppAutomationsN8nRoute
  AppAutomationsRunsRoute: typeof AppAutomationsRunsRoute
  AppAutomationsTemplatesRoute: typeof AppAutomationsTemplatesRoute
  AppBudgetsTabRoute: typeof AppBudgetsTabRoute
  AppCalendarOverlapRoute: typeof AppCalendarOverlapRoute
  AppCallsPlaylistsRoute: typeof AppCallsPlaylistsRoute
  AppCampaignsCampaignRoute: typeof AppCampaignsCampaignRoute
  AppCatalogueTabRoute: typeof AppCatalogueTabRoute
  AppCatalogueStoreRoute: typeof AppCatalogueStoreRoute
  AppChatChannelRoute: typeof AppChatChannelRoute
  AppClientsDuplicatesRoute: typeof AppClientsDuplicatesRoute
  AppContactsContactRoute: typeof AppContactsContactRoute
  AppCyclesCycleRoute: typeof AppCyclesCycleRoute
  AppDashboardsDashboardRoute: typeof AppDashboardsDashboardRoute
  AppDealsDealRoute: typeof AppDealsDealRoute
  AppDealsFollowUpsRoute: typeof AppDealsFollowUpsRoute
  AppDocsDocRoute: typeof AppDocsDocRoute
  AppFilesFolderRoute: typeof AppFilesFolderRoute
  AppFilesStorageRoute: typeof AppFilesStorageRoute
  AppFilesTrashRoute: typeof AppFilesTrashRoute
  AppFinanceTabRoute: typeof AppFinanceTabRoute
  AppFreelancersFreelancerRoute: typeof AppFreelancersFreelancerRoute
  AppFreelancersPayoutsRoute: typeof AppFreelancersPayoutsRoute
  AppFreelancersRequisitionsRoute: typeof AppFreelancersRequisitionsRoute
  AppHiringJobRoute: typeof AppHiringJobRoute
  AppImportTypeRoute: typeof AppImportTypeRoute
  AppInboxThreadRoute: typeof AppInboxThreadRoute
  AppInboxWhatsappTemplatesRoute: typeof AppInboxWhatsappTemplatesRoute
  AppInitiativesInitiativeRoute: typeof AppInitiativesInitiativeRoute
  AppInvoicesInvoiceRoute: typeof AppInvoicesInvoiceRoute
  AppInvoicesAgingRoute: typeof AppInvoicesAgingRoute
  AppLabFamilyRoute: typeof AppLabFamilyRoute
  AppMeetingsMeetingRoute: typeof AppMeetingsMeetingRoute
  AppOnboardingRunRoute: typeof AppOnboardingRunRoute
  AppOneOnOnesPersonRoute: typeof AppOneOnOnesPersonRoute
  AppOutreachSequenceRoute: typeof AppOutreachSequenceRoute
  AppOutreachDeliverabilityRoute: typeof AppOutreachDeliverabilityRoute
  AppOutreachListsRoute: typeof AppOutreachListsRoute
  AppOutreachMailboxesRoute: typeof AppOutreachMailboxesRoute
  AppOutreachWarmupRoute: typeof AppOutreachWarmupRoute
  AppPortfoliosPortfolioRoute: typeof AppPortfoliosPortfolioRoute
  AppProofsProofRoute: typeof AppProofsProofRoute
  AppProposalsTemplatesRoute: typeof AppProposalsTemplatesRoute
  AppQueuesRoleRoute: typeof AppQueuesRoleRoute
  AppReportsReportRoute: typeof AppReportsReportRoute
  AppReportsAttributionRoute: typeof AppReportsAttributionRoute
  AppReportsRevenueAnalyticsRoute: typeof AppReportsRevenueAnalyticsRoute
  AppReportsTargetsRoute: typeof AppReportsTargetsRoute
  AppSalesRepRoute: typeof AppSalesRepRoute
  AppSalesRulesRoute: typeof AppSalesRulesRoute
  AppSpacesSpaceRoute: typeof AppSpacesSpaceRoute
  AppSubscriptionsSubscriptionRoute: typeof AppSubscriptionsSubscriptionRoute
  AppSubscriptionsRecurringRoute: typeof AppSubscriptionsRecurringRoute
  AppTasksKeyRoute: typeof AppTasksKeyRoute
  AppTeamMemberRoute: typeof AppTeamMemberRoute
  AppTicketsTicketRoute: typeof AppTicketsTicketRoute
  AppTimeApprovalsRoute: typeof AppTimeApprovalsRoute
  AppTimeLedgerRoute: typeof AppTimeLedgerRoute
  AppTimeTimerRoute: typeof AppTimeTimerRoute
  AppToursStuckRoute: typeof AppToursStuckRoute
  AppWhiteboardsIdRoute: typeof AppWhiteboardsIdRoute
  AppAgreementsIndexRoute: typeof AppAgreementsIndexRoute
  AppApprovalsIndexRoute: typeof AppApprovalsIndexRoute
  AppAssetsIndexRoute: typeof AppAssetsIndexRoute
  AppAutomationsIndexRoute: typeof AppAutomationsIndexRoute
  AppBookingsIndexRoute: typeof AppBookingsIndexRoute
  AppBudgetsIndexRoute: typeof AppBudgetsIndexRoute
  AppCalendarIndexRoute: typeof AppCalendarIndexRoute
  AppCallsIndexRoute: typeof AppCallsIndexRoute
  AppCampaignsIndexRoute: typeof AppCampaignsIndexRoute
  AppChatIndexRoute: typeof AppChatIndexRoute
  AppClientsIndexRoute: typeof AppClientsIndexRoute
  AppContactsIndexRoute: typeof AppContactsIndexRoute
  AppCyclesIndexRoute: typeof AppCyclesIndexRoute
  AppDashboardsIndexRoute: typeof AppDashboardsIndexRoute
  AppDealsIndexRoute: typeof AppDealsIndexRoute
  AppDocsIndexRoute: typeof AppDocsIndexRoute
  AppFilesIndexRoute: typeof AppFilesIndexRoute
  AppFormsIndexRoute: typeof AppFormsIndexRoute
  AppFreelancersIndexRoute: typeof AppFreelancersIndexRoute
  AppGettingStartedIndexRoute: typeof AppGettingStartedIndexRoute
  AppHelpCentreIndexRoute: typeof AppHelpCentreIndexRoute
  AppHiringIndexRoute: typeof AppHiringIndexRoute
  AppInboxIndexRoute: typeof AppInboxIndexRoute
  AppInitiativesIndexRoute: typeof AppInitiativesIndexRoute
  AppInvoicesIndexRoute: typeof AppInvoicesIndexRoute
  AppLeaderboardIndexRoute: typeof AppLeaderboardIndexRoute
  AppMeetingsIndexRoute: typeof AppMeetingsIndexRoute
  AppMyWorkIndexRoute: typeof AppMyWorkIndexRoute
  AppNotificationsIndexRoute: typeof AppNotificationsIndexRoute
  AppOIndexRoute: typeof AppOIndexRoute
  AppOnboardingIndexRoute: typeof AppOnboardingIndexRoute
  AppOutreachIndexRoute: typeof AppOutreachIndexRoute
  AppPaymentsIndexRoute: typeof AppPaymentsIndexRoute
  AppPoliciesIndexRoute: typeof AppPoliciesIndexRoute
  AppPortfoliosIndexRoute: typeof AppPortfoliosIndexRoute
  AppPresetsIndexRoute: typeof AppPresetsIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppProofsIndexRoute: typeof AppProofsIndexRoute
  AppProposalsIndexRoute: typeof AppProposalsIndexRoute
  AppQueuesIndexRoute: typeof AppQueuesIndexRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
  AppReviewsIndexRoute: typeof AppReviewsIndexRoute
  AppSalesIndexRoute: typeof AppSalesIndexRoute
  AppScheduleIndexRoute: typeof AppScheduleIndexRoute
  AppSearchIndexRoute: typeof AppSearchIndexRoute
  AppSocialIndexRoute: typeof AppSocialIndexRoute
  AppSubscriptionsIndexRoute: typeof AppSubscriptionsIndexRoute
  AppTeamIndexRoute: typeof AppTeamIndexRoute
  AppTicketsIndexRoute: typeof AppTicketsIndexRoute
  AppTimeOffIndexRoute: typeof AppTimeOffIndexRoute
  AppTimeIndexRoute: typeof AppTimeIndexRoute
  AppToursIndexRoute: typeof AppToursIndexRoute
  AppTriageIndexRoute: typeof AppTriageIndexRoute
  AppUpdatesIndexRoute: typeof AppUpdatesIndexRoute
  AppVaultIndexRoute: typeof AppVaultIndexRoute
  AppWebFeedbackIndexRoute: typeof AppWebFeedbackIndexRoute
  AppAutomationsMessagesTemplateRoute: typeof AppAutomationsMessagesTemplateRoute
  AppBookingsPagesPageRoute: typeof AppBookingsPagesPageRoute
  AppClientsClientTabRoute: typeof AppClientsClientTabRoute
  AppClientsClientLifecycleRoute: typeof AppClientsClientLifecycleRoute
  AppDashboardsTemplateTemplateRoute: typeof AppDashboardsTemplateTemplateRoute
  AppFilesFileOfficeRoute: typeof AppFilesFileOfficeRoute
  AppFormsFormAnalyticsRoute: typeof AppFormsFormAnalyticsRoute
  AppFormsFormEditRoute: typeof AppFormsFormEditRoute
  AppFormsFormResponsesRoute: typeof AppFormsFormResponsesRoute
  AppMyWorkListsListRoute: typeof AppMyWorkListsListRoute
  AppOObjectIdRoute: typeof AppOObjectIdRoute
  AppOnboardingTemplatesTemplateRoute: typeof AppOnboardingTemplatesTemplateRoute
  AppProjectsProjectTabRoute: typeof AppProjectsProjectTabRoute
  AppProjectsProjectScopeRoute: typeof AppProjectsProjectScopeRoute
  AppProposalsProposalAnalyticsRoute: typeof AppProposalsProposalAnalyticsRoute
  AppProposalsProposalEditRoute: typeof AppProposalsProposalEditRoute
  AppReportsClientsClientRoute: typeof AppReportsClientsClientRoute
  AppReportsPresentReportRoute: typeof AppReportsPresentReportRoute
  AppReviewsClientQuarterRoute: typeof AppReviewsClientQuarterRoute
  AppSettingsGroupPageRoute: typeof AppSettingsGroupPageRoute
  AppTemplatesKindTemplateRoute: typeof AppTemplatesKindTemplateRoute
  AppWorkTemplatesTemplateRoute: typeof AppWorkTemplatesTemplateRoute
  AppAutomationsWorkflowIndexRoute: typeof AppAutomationsWorkflowIndexRoute
  AppAutomationsMessagesIndexRoute: typeof AppAutomationsMessagesIndexRoute
  AppOObjectIndexRoute: typeof AppOObjectIndexRoute
  AppReportsClientsIndexRoute: typeof AppReportsClientsIndexRoute
  AppWorkTemplatesIndexRoute: typeof AppWorkTemplatesIndexRoute
  AppAutomationsWorkflowRunsRunRoute: typeof AppAutomationsWorkflowRunsRunRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSplatRoute: AppSplatRoute,
  AppAppsRoute: AppAppsRoute,
  AppAudiencesRoute: AppAudiencesRoute,
  AppExpensesRoute: AppExpensesRoute,
  AppFeedbackRoute: AppFeedbackRoute,
  AppFollowsRoute: AppFollowsRoute,
  AppGoalsRoute: AppGoalsRoute,
  AppHomeRoute: AppHomeRoute,
  AppPortfolioRoute: AppPortfolioRoute,
  AppPurchasesRoute: AppPurchasesRoute,
  AppSurveysRoute: AppSurveysRoute,
  AppWebsiteRoute: AppWebsiteRoute,
  AppWorkspacesRoute: AppWorkspacesRoute,
  AppAgreementsAgreementRoute: AppAgreementsAgreementRoute,
  AppAgreementsIdReviewsRoute: AppAgreementsIdReviewsRoute,
  AppAutomationsMapRoute: AppAutomationsMapRoute,
  AppAutomationsN8nRoute: AppAutomationsN8nRoute,
  AppAutomationsRunsRoute: AppAutomationsRunsRoute,
  AppAutomationsTemplatesRoute: AppAutomationsTemplatesRoute,
  AppBudgetsTabRoute: AppBudgetsTabRoute,
  AppCalendarOverlapRoute: AppCalendarOverlapRoute,
  AppCallsPlaylistsRoute: AppCallsPlaylistsRoute,
  AppCampaignsCampaignRoute: AppCampaignsCampaignRoute,
  AppCatalogueTabRoute: AppCatalogueTabRoute,
  AppCatalogueStoreRoute: AppCatalogueStoreRoute,
  AppChatChannelRoute: AppChatChannelRoute,
  AppClientsDuplicatesRoute: AppClientsDuplicatesRoute,
  AppContactsContactRoute: AppContactsContactRoute,
  AppCyclesCycleRoute: AppCyclesCycleRoute,
  AppDashboardsDashboardRoute: AppDashboardsDashboardRoute,
  AppDealsDealRoute: AppDealsDealRoute,
  AppDealsFollowUpsRoute: AppDealsFollowUpsRoute,
  AppDocsDocRoute: AppDocsDocRoute,
  AppFilesFolderRoute: AppFilesFolderRoute,
  AppFilesStorageRoute: AppFilesStorageRoute,
  AppFilesTrashRoute: AppFilesTrashRoute,
  AppFinanceTabRoute: AppFinanceTabRoute,
  AppFreelancersFreelancerRoute: AppFreelancersFreelancerRoute,
  AppFreelancersPayoutsRoute: AppFreelancersPayoutsRoute,
  AppFreelancersRequisitionsRoute: AppFreelancersRequisitionsRoute,
  AppHiringJobRoute: AppHiringJobRoute,
  AppImportTypeRoute: AppImportTypeRoute,
  AppInboxThreadRoute: AppInboxThreadRoute,
  AppInboxWhatsappTemplatesRoute: AppInboxWhatsappTemplatesRoute,
  AppInitiativesInitiativeRoute: AppInitiativesInitiativeRoute,
  AppInvoicesInvoiceRoute: AppInvoicesInvoiceRoute,
  AppInvoicesAgingRoute: AppInvoicesAgingRoute,
  AppLabFamilyRoute: AppLabFamilyRoute,
  AppMeetingsMeetingRoute: AppMeetingsMeetingRoute,
  AppOnboardingRunRoute: AppOnboardingRunRoute,
  AppOneOnOnesPersonRoute: AppOneOnOnesPersonRoute,
  AppOutreachSequenceRoute: AppOutreachSequenceRoute,
  AppOutreachDeliverabilityRoute: AppOutreachDeliverabilityRoute,
  AppOutreachListsRoute: AppOutreachListsRoute,
  AppOutreachMailboxesRoute: AppOutreachMailboxesRoute,
  AppOutreachWarmupRoute: AppOutreachWarmupRoute,
  AppPortfoliosPortfolioRoute: AppPortfoliosPortfolioRoute,
  AppProofsProofRoute: AppProofsProofRoute,
  AppProposalsTemplatesRoute: AppProposalsTemplatesRoute,
  AppQueuesRoleRoute: AppQueuesRoleRoute,
  AppReportsReportRoute: AppReportsReportRoute,
  AppReportsAttributionRoute: AppReportsAttributionRoute,
  AppReportsRevenueAnalyticsRoute: AppReportsRevenueAnalyticsRoute,
  AppReportsTargetsRoute: AppReportsTargetsRoute,
  AppSalesRepRoute: AppSalesRepRoute,
  AppSalesRulesRoute: AppSalesRulesRoute,
  AppSpacesSpaceRoute: AppSpacesSpaceRoute,
  AppSubscriptionsSubscriptionRoute: AppSubscriptionsSubscriptionRoute,
  AppSubscriptionsRecurringRoute: AppSubscriptionsRecurringRoute,
  AppTasksKeyRoute: AppTasksKeyRoute,
  AppTeamMemberRoute: AppTeamMemberRoute,
  AppTicketsTicketRoute: AppTicketsTicketRoute,
  AppTimeApprovalsRoute: AppTimeApprovalsRoute,
  AppTimeLedgerRoute: AppTimeLedgerRoute,
  AppTimeTimerRoute: AppTimeTimerRoute,
  AppToursStuckRoute: AppToursStuckRoute,
  AppWhiteboardsIdRoute: AppWhiteboardsIdRoute,
  AppAgreementsIndexRoute: AppAgreementsIndexRoute,
  AppApprovalsIndexRoute: AppApprovalsIndexRoute,
  AppAssetsIndexRoute: AppAssetsIndexRoute,
  AppAutomationsIndexRoute: AppAutomationsIndexRoute,
  AppBookingsIndexRoute: AppBookingsIndexRoute,
  AppBudgetsIndexRoute: AppBudgetsIndexRoute,
  AppCalendarIndexRoute: AppCalendarIndexRoute,
  AppCallsIndexRoute: AppCallsIndexRoute,
  AppCampaignsIndexRoute: AppCampaignsIndexRoute,
  AppChatIndexRoute: AppChatIndexRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
  AppContactsIndexRoute: AppContactsIndexRoute,
  AppCyclesIndexRoute: AppCyclesIndexRoute,
  AppDashboardsIndexRoute: AppDashboardsIndexRoute,
  AppDealsIndexRoute: AppDealsIndexRoute,
  AppDocsIndexRoute: AppDocsIndexRoute,
  AppFilesIndexRoute: AppFilesIndexRoute,
  AppFormsIndexRoute: AppFormsIndexRoute,
  AppFreelancersIndexRoute: AppFreelancersIndexRoute,
  AppGettingStartedIndexRoute: AppGettingStartedIndexRoute,
  AppHelpCentreIndexRoute: AppHelpCentreIndexRoute,
  AppHiringIndexRoute: AppHiringIndexRoute,
  AppInboxIndexRoute: AppInboxIndexRoute,
  AppInitiativesIndexRoute: AppInitiativesIndexRoute,
  AppInvoicesIndexRoute: AppInvoicesIndexRoute,
  AppLeaderboardIndexRoute: AppLeaderboardIndexRoute,
  AppMeetingsIndexRoute: AppMeetingsIndexRoute,
  AppMyWorkIndexRoute: AppMyWorkIndexRoute,
  AppNotificationsIndexRoute: AppNotificationsIndexRoute,
  AppOIndexRoute: AppOIndexRoute,
  AppOnboardingIndexRoute: AppOnboardingIndexRoute,
  AppOutreachIndexRoute: AppOutreachIndexRoute,
  AppPaymentsIndexRoute: AppPaymentsIndexRoute,
  AppPoliciesIndexRoute: AppPoliciesIndexRoute,
  AppPortfoliosIndexRoute: AppPortfoliosIndexRoute,
  AppPresetsIndexRoute: AppPresetsIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppProofsIndexRoute: AppProofsIndexRoute,
  AppProposalsIndexRoute: AppProposalsIndexRoute,
  AppQueuesIndexRoute: AppQueuesIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppReviewsIndexRoute: AppReviewsIndexRoute,
  AppSalesIndexRoute: AppSalesIndexRoute,
  AppScheduleIndexRoute: AppScheduleIndexRoute,
  AppSearchIndexRoute: AppSearchIndexRoute,
  AppSocialIndexRoute: AppSocialIndexRoute,
  AppSubscriptionsIndexRoute: AppSubscriptionsIndexRoute,
  AppTeamIndexRoute: AppTeamIndexRoute,
  AppTicketsIndexRoute: AppTicketsIndexRoute,
  AppTimeOffIndexRoute: AppTimeOffIndexRoute,
  AppTimeIndexRoute: AppTimeIndexRoute,
  AppToursIndexRoute: AppToursIndexRoute,
  AppTriageIndexRoute: AppTriageIndexRoute,
  AppUpdatesIndexRoute: AppUpdatesIndexRoute,
  AppVaultIndexRoute: AppVaultIndexRoute,
  AppWebFeedbackIndexRoute: AppWebFeedbackIndexRoute,
  AppAutomationsMessagesTemplateRoute: AppAutomationsMessagesTemplateRoute,
  AppBookingsPagesPageRoute: AppBookingsPagesPageRoute,
  AppClientsClientTabRoute: AppClientsClientTabRoute,
  AppClientsClientLifecycleRoute: AppClientsClientLifecycleRoute,
  AppDashboardsTemplateTemplateRoute: AppDashboardsTemplateTemplateRoute,
  AppFilesFileOfficeRoute: AppFilesFileOfficeRoute,
  AppFormsFormAnalyticsRoute: AppFormsFormAnalyticsRoute,
  AppFormsFormEditRoute: AppFormsFormEditRoute,
  AppFormsFormResponsesRoute: AppFormsFormResponsesRoute,
  AppMyWorkListsListRoute: AppMyWorkListsListRoute,
  AppOObjectIdRoute: AppOObjectIdRoute,
  AppOnboardingTemplatesTemplateRoute: AppOnboardingTemplatesTemplateRoute,
  AppProjectsProjectTabRoute: AppProjectsProjectTabRoute,
  AppProjectsProjectScopeRoute: AppProjectsProjectScopeRoute,
  AppProposalsProposalAnalyticsRoute: AppProposalsProposalAnalyticsRoute,
  AppProposalsProposalEditRoute: AppProposalsProposalEditRoute,
  AppReportsClientsClientRoute: AppReportsClientsClientRoute,
  AppReportsPresentReportRoute: AppReportsPresentReportRoute,
  AppReviewsClientQuarterRoute: AppReviewsClientQuarterRoute,
  AppSettingsGroupPageRoute: AppSettingsGroupPageRoute,
  AppTemplatesKindTemplateRoute: AppTemplatesKindTemplateRoute,
  AppWorkTemplatesTemplateRoute: AppWorkTemplatesTemplateRoute,
  AppAutomationsWorkflowIndexRoute: AppAutomationsWorkflowIndexRoute,
  AppAutomationsMessagesIndexRoute: AppAutomationsMessagesIndexRoute,
  AppOObjectIndexRoute: AppOObjectIndexRoute,
  AppReportsClientsIndexRoute: AppReportsClientsIndexRoute,
  AppWorkTemplatesIndexRoute: AppWorkTemplatesIndexRoute,
  AppAutomationsWorkflowRunsRunRoute: AppAutomationsWorkflowRunsRunRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  JoinRoute: JoinRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  TrustRoute: TrustRoute,
  ApplyJobRoute: ApplyJobRoute,
  HelpSlugRoute: HelpSlugRoute,
  InviteTokenRoute: InviteTokenRoute,
  NTokenRoute: NTokenRoute,
  PortalBriefsRoute: PortalBriefsRoute,
  PortalCalendarRoute: PortalCalendarRoute,
  PortalChangesRoute: PortalChangesRoute,
  PortalFilesRoute: PortalFilesRoute,
  PortalFormsRoute: PortalFormsRoute,
  PortalHelpRoute: PortalHelpRoute,
  PortalMessagesRoute: PortalMessagesRoute,
  PortalMoneyRoute: PortalMoneyRoute,
  PortalPlansRoute: PortalPlansRoute,
  PortalReportsRoute: PortalReportsRoute,
  PortalRequestsRoute: PortalRequestsRoute,
  PortalSettingsRoute: PortalSettingsRoute,
  PortalSignInRoute: PortalSignInRoute,
  PortalSocialRoute: PortalSocialRoute,
  PortalStoreRoute: PortalStoreRoute,
  PortalTicketsRoute: PortalTicketsRoute,
  PortalWelcomeRoute: PortalWelcomeRoute,
  RTokenRoute: RTokenRoute,
  SetupStepRoute: SetupStepRoute,
  FreelancerIndexRoute: FreelancerIndexRoute,
  PortalIndexRoute: PortalIndexRoute,
  PActionTokenRoute: PActionTokenRoute,
  PBookSlugRoute: PBookSlugRoute,
  PFormSlugRoute: PFormSlugRoute,
  PFreelancerTokenRoute: PFreelancerTokenRoute,
  PHelpSlugRoute: PHelpSlugRoute,
  PPayTokenRoute: PPayTokenRoute,
  PProposalTokenRoute: PProposalTokenRoute,
  PShareTokenRoute: PShareTokenRoute,
  PSignTokenRoute: PSignTokenRoute,
  PSurveyTokenRoute: PSurveyTokenRoute,
  PTestimonialTokenRoute: PTestimonialTokenRoute,
  PUnsubscribeTokenRoute: PUnsubscribeTokenRoute,
  PUploadTokenRoute: PUploadTokenRoute,
  PortalApprovalsApprovalRoute: PortalApprovalsApprovalRoute,
  PortalAppsTabRoute: PortalAppsTabRoute,
  PortalProjectsProjectRoute: PortalProjectsProjectRoute,
  PortalApprovalsIndexRoute: PortalApprovalsIndexRoute,
  PortalProjectsIndexRoute: PortalProjectsIndexRoute,
  PBookManageTokenRoute: PBookManageTokenRoute,
  PReferralWsCodeRoute: PReferralWsCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
